import jZh from "./j-zh-cn.js";
import liveManagement from "./liveManagement";
import revenueActivity from "./revenueActivity-zh-cn";
import newStarRoom from "./newStarRoom-zh-cn";
import annualFestival from "./annualFestival-zh-cn";
import groupManagement from "./groupManagement-zh-cn";
import blindBox from "./blindBox-zh-cn";
import auction from "./auction-zh-cn";
import approval from "./approval-zh-cn";
import groupActivity from "./groupActivity-zh-cn";
import worldCup from "./worldCup-zh-cn";
import nameplate from "./nameplate-zh-cn";
import community from "./community";

export default {
  router: {
    index: {
      taskDeploy:"任务配置",
      home: "首页",
      pageSearch1: "用户查询管理",
      pageSearch2: "用户查询",
      pageSearch2_1: "注销用户信息",
      pageSearch3: "用户详情",
      pageSearch4: "群组详情",
      pageRoom1: "房间管理",
      pageRoom2: "房间查询",
      pageRoom3: "房间标签",
      pageRoom4: "房间背景管理",
      pageRoom5: "房间背景编辑",
      pageRoom6: "活动审核",
      pageRoom7: "房主认证",
      pageRoom8: "房间流水详情",
      pageRoom9: "房间监控列表",
      pageRoom10: "房间接待",
      pageRoom11: "房间转盘",
      pageRoom12: "房间接待详情",
      pageRoom13: "房间整点流水",
      pageRoom14: "房间扶持",
      pageAd: "广告&弹窗",
      riskControl: "充值风控管理",
      pageGift1: "礼物管理",
      faceManagement:'表情管理',
      pageFamily: "家族信息查询",
      pageFamily2: "家族解散申请",
      pagetion1: "运营活动配置",
      pageProps1: "礼物道具管理",
      pageProps2: "道具管理",
      pageProps3: "销售统计",
      pageProps4: "卡券管理",
      pageProps5: "用户列表",
      pageProps6: "铭牌管理",
      pageProps7: "戒指管理",
      pageProps8: "戒指发放",
      pageAdmin1: "管理员",
      pageAdmin2: "超级管理员",
      pageAdmin3: "国家管理员",
      pageSensitive: "敏感字管理",
      pageCountry1: "国家管理",
      pageHost1: "主播管理",
      pageHost1_1: "主播管理及结算",
      pageHost2: "历史扣除钻石记录",
      pageHost3: "房间贡献榜单列表",
      pageAgent1: "代理管理",
      pageAgent2: "ta的充值记录",
      pageAgent3: "代理充值列表",
      pageAgent4: "月度销售统计",
      pageAgent5: "订阅余额消费记录",
      bindList:'绑定名单列表',
      pageCrystal: "房间水晶",
      lostOrder: "失败订单查询",
      appleLostOrder: "apple丢单查询",
      kaManagement: "KA管理",
      refundCenter: "退款处理中心",
      pageAccount1: "管理员账号设置",
      pageAccount2: "系统帐号设置",
      pageManagement1: "角色权限管理",
      pageManagement2: "角色权限设置",
      operationLog1: "操作日志",
      roomColumn: "Banner管理",
      liveManagement: "直播管理",
      videoSource: "视频源管理",
      voiceLive: "语音房直播",
      roomLive: "直播间直播",
      groupManagement: "群组管理",
      violatingUser: "违规用户管理",
      systemMessage: "系统消息",
      sendMessage: "发送消息",
      notList: "未发放列表",
      supportBlacklist: "扶持黑名单",
      scriptManagement:'脚本管理',
      housePatrolScript:'巡房脚本管理',
      partyRoomScript:'派对房间脚本',

      ActivityManagement: "活动管理",
      ActivityManagement_1: "长期活动",
      activityDeploy: "活动配置",
      activityBlackListManagement:'黑名单管理',
      activityShieldManagement:'屏蔽名单',
      activityPage1: "新周星",
      activityPage2: "星空诗人",
      activityPage3: "抽奖活动",
      activityPage4: "砸金蛋",
      activityPage5: "充值活动",
      activityPage5_1: "累计充值V2",
      activityPage6: "奖励配置",
      activityPage7: "cp认证",
      activityPage8: "锦标赛",
      activityPage9: "营收活动配置",
      activityPage10: "每日盲盒",
      groupActivity:'群组推广',
      invitationMessage: "邀请系统",
      developerMessage: "开发人员管理",
      equipmentManagement: "设备管理",
      ipQuery: "ip信息查询",
      familyLeague: "家族联赛",
      annualDrums: "年度战鼓",
      honorWall: "荣誉墙",
      annualFestival: "盛典投票模板",
      millionsPk: "百万富豪Pk",
      ludoPage: "ludo黑名单",
      matchQuery: "匹配查询",
      userRegistration: "新用户注册",
      setting: "设置",
      feedbackList: "反馈列表",
      managementList: "管理靓号ID列表",
      specialMoment: "特殊时刻",
      specialMomentV3: "特殊时刻V3",
      roomElection: "房间选举",
      newStarRoom:'新星房间',
      riskcontrolManagement: "充值风控管理",
      riskManagement: "风控管理",
      familyStar: "家族之星",
      jackpotActivities: '竞猜活动',
      theVoice: '好声音',
      newUserReview: '欢迎派对申请管理',
      pageKnowledge:'热门QA管理',
      pageUser1:'用户举报',
      bdManagement: 'BD管理',
      guildManagement:'公会管理',
      guildStatistics:'公会统计',
      gameStatistics:'游戏数据看板',
      risk: "拦截黑名单",

      login: "登录",
      error401: "error 401",
      error404: "error 404",
      error500: "error 500",

      auction:'拍卖活动',
      applyAndapproval:'审批',
      apply:'金币道具申请',
      approval:'金币道具审批',
      approvalSet:'审批设置',
      addCoinsApply:'添加金币申请',
      addPropsApply:'添加道具申请',
      worldCup:'世界杯',

      pageData:'数据统计',
      pagePlatform1: '平台统计',
      pagePlatformAr: '阿语区运营数据',
      pagePlatformAll: '全区运营数据',
      pagePlatformNotAr: '非阿语区运营数据',
      pageTreasureHunt1:'水果机统计',
      pageRoom11_1:'转盘统计',
      foodie:'foodie统计',

      templateActivity:'模板活动',
      templateActTask:'模板活动任务配置',
      sudGame:'休闲游戏统计'
    },
    router: {
      beforeClose: {
        sureClose: "确定要关闭这一页吗"
      }
    }
  },
  views: {
    public: {
      more: "查看",
      bancause: "封禁原因:",
      banFrom: "封禁至",
      copyUrl: "复制Url",
      null: "无",
      operatSuccess: "操作成功",
      operatError: "操作失败",
      pass: "通过",
      refuse: "拒绝",
      passed: "已通过",
      refused: "已拒绝",
      close: "关闭",
      submit: "提交",
      yes: "是",
      no: "否",
      sure: "确定",
      cancel: "取消",
      prompt: "提示",
      operation: "操作",
      delete: "删除",
      edit: "编辑",
      query: "查询",
      update: "修改",
      turkish: "土耳其语",
      arabic: "阿语",
      indonesian: "印尼语",
      en: "英语",
      all: "全部",
      noPermission: "暂无权限",
      pleaseChoose: "请选择",
      upload: "上传",
      none: "无",
      sex: "色情/性",
      curse: "侮辱谩骂",
      religion: "不尊重宗教",
      terroristActivities: "恐怖活动",
      violationOfLaw: "违法违规",
      propaganda: "宣传其他App",
      resetHeadImg: "重置头像",
      confirmOpear: "确认执行该操作?",
      noneData: "暂无数据",
      operatSuccessUpdate: "操作成功，更新状态中",
      // 新增补
      male: "男",
      confidential: "保密",
      female: "女",
      ban24h: "封禁24小时",
      ban72h: "封禁72小时",
      ban30D: "封禁30天",
      permanentBan: "永久封禁",
      save: "保存",
      chooseImg: "选择图片",
      clear: "清除",
      chooseAll: "全选",
      search: "搜索",
      pleaseChooseTarget: "请选择操作对象",
      showBigImg: "查看大图",
      date:'日期',
      startTime: "开始时间",
      endTime: "结束时间",
      enterRoomId: "请输入房间靓号id",
      exportText: "导出",
      minute5: "5分钟",
      hour1: "1小时",
      hour2: "2小时",
      hour4: "4小时",
      hour6: "6小时",
      hour12: "12小时",
      hour24: "24小时",
      add: "添加",

      areaText1: "英语",
      areaText2: "阿语",
      areaText3: "印尼语",
      areaText4: "土耳其语",
      areaText5: "印地语",
      areaText6: "越南语",
      areaText7: "泰语",
      saveEdit: "保存并创建关联配对",
      saveEdit2: "保存并创建关联",

      chooseVideo:'选择视频',

      chooseVideoOrInputUrl:'输入视频地址',

      selectMore: "勾选多选",
      time: "时间",
      title:'标题',

      imageUploadLimit:'上传图片不能超过{size}MB',

      chooseFile:'选择文件',
      region:'区域',
      picture:'图片',
      country:'国家',
      remark:'备注',
      // ----

      common: "普通",
      exclusive: "专属",

      deduct: "扣除",
      newly: "新增",
      deductDay: "扣除天数",
      deductDay1: "扣除个数",

      dislodge: "清除",
      have: "有",

      ban24: "封禁24小时",
      ban72: "封禁72小时",
      ban3: "封禁3小时",
      banTime: "封禁时间",
      banReason: "封禁原因",
      banDesc: "封禁描述",

      saveBtn: "保存",

      chooseTime: "选择时间",
      topTime: "上架时间",
      bottomTime: "下架时间",
      onlineTime: "上线时间",
      transferTime: "转账时间",
      startTimeNotNull: "开始时间不能为空",
      pleaseEnter: "请输入用户ID",
      pleaseEnterAnchor: "请输入主播ID",
      pleaseEnterId: "请输入用户ID",
      matchCycle: "批次号",
      startAndEndTime: "开始时间或结束时间不能为空",
      countryText: "国家",
      orderCode: "订单号",
      orderPlaceholder: "请输入订单号",
      batchPass: "批量通过",
      batchReject: "批量拒绝",
      batchDispose: "批量处理",
      groupFu: "该用户没有群组",
      anchorNameFu: "请选择公会名",
      association: "公会",
      banned_harass: "在多个房间骚扰",
      banned_privacy: "侵犯他人隐私",
      banned_eroticism: "色情暴力内容",
      banned_damage: "损害官方利益",
      imgArVideo: "查看图片/视频",
      showBigVideo: "视频预览",
      operationSuccess: "操作成功",
      user_sum_recharge: "用户总充值：",
      allArea: "区域",
      onlineArea: "上线区域",
      entirelyArea: "全区",
      arArea: "阿语区",
      noArArea: "非阿语区",
      appointCountry: "指定国家",
      onlineCountry: "上线国家",
      downloadTemplate: "下载模板",
      writeFull: "请填写完整",
      addAccount: "创建账号",
      othersArea: "其他区域",
      addedArea: "上架区域",
      infinTeSex: "不限",
      receptionLevel: "接收者等级",
      levelTop: "财富等级5级以上"
    },
    userDestroy:{
      originalID:'原靓号ID',
      destroyID:'分配ID',
      addTime:'提交注销时间',
      handleTime:'注销到期时间',
      status:'注销状态',
      status1:'注销中',
      status2:'已注销',
      status3:'已取消',

      totalRecharge:'充值总额',
      banCount:'封禁次数',
    },
    riskcontrolManagement: {
      tab1: "风险帐号",
      tab2: "拦截日志",
      tab1text1: "拦截渠道",
      tab1text2: "已拦截次数",
      tab1text3: "最近拦截时间",
      tab1text4: "等级",
      tab1text5: "金币余额",
      tab1text55: "钻石余额",
      tab1text6: "总充值（）",
      tab1text7: "注册IP(帐号数)",
      tab1text8: "机器码",
      tab1text9: "添加时间",
      tab1text10: "添加人",
      tab1text11: "新增风险帐号",
      tab1text12: "将ip加入风险控制",
      tab1text13: "将机器码加入风险控制",
      tab1text14: "特征码(可以填写支付帐号如PayPal帐号，未填写则只拦截该帐号)",

      tab1text15: "批量删除",
      tab1text16: "修改风险帐号"
    },
    refundCenter: {
      refundOrderNo: "退款订单号",
      cumulativeRepayment: "累计还款",
      lastWarningTime: "最近警告时间",
      refundDetails: "退款明细",
      repaymentRecord: "还款记录",
      frozenAccountDetails: "冻结账号明细",
      refundWarning: "退款警告",
      refundWarningSure: "确认发送退款警告？",
      freezeAccount: "冻结账号",
      binChargeType: "禁用充值方式",
      repaymentProcessing: "还款处理",
      refundedCoins: "退款金币数",
      refundTime: "退款时间",
      totalSameIp: "共",
      selectUser: '请先选择用户',
      selectRechargeType:'请选择禁用充值类型',
      deviTotal_tip:"该设备下所有账号累计退款：%%%%，累计充值：####",
      sureBanRechargeType:"确定禁用充值方式?",
      repaymentType:'还款渠道',
      rePay:{
        formLabel1:'处理订单',
        formLabel2:'退款单数',
        formLabel3:'退款金额',
        formLabel4:'还款金额',
        formLabel5:'还款方式',
        formLabel6:'扣除金币',
        formLabel7:'还款单号',
        formLabel8:'备注',

        placeholder1:'请输入金币数量',
        placeholder2:'请输入订单号',


        formText1:'仅限选择的退款订单',
        formText2:'该账号的全部退款单',
        formText3:'还款成功后解除冻结和解除封禁',
      },
      palpay: 'palpay支付',
      payoneer:'payoneer',
      coins:'扣币',

      rePayDetail:'还款明细',
      tab2Text1:'还款操作人',
      tab2Text2:'还款金额',
      tab2Text3:'还款方式',
      tab2Text4:'还款单号',
      tab2Text5:'还款备注',
      tab2Text6:'还款时间',
      tab2Text7:'冲减退款额',
      tab2Text8:'冲减退单数',

      tab3Text1:'冻结时间',
      tab3Text2:'冻结人',
      tab3Text3:'退款金币数',
      tab3Text4:'累计退款金额',
      tab3Text5:'谷歌/苹果充值金额',
      tab3Text6:'最后警告时间',
      tab3Text7:'禁用充值方式',
      tab3Text8:'注册ip',
      tab3Text9:'设备码',

      repaymentError:'还款处理只能选择同一个用户',
      create_time:'充值时间',

      tab3Text10:'封禁至',
      tab3Text11:'永久封禁',

    },
    userInformation: {
      enterId: "请输入用户靓号id",
      userId: "用户靓号",
      invalidId: "输入的id无效",
      noUser: "未找到该用户",
      search: "查询",
      // 新增补
      banCount: "封禁次数",
      times: "{counts}次",
      showDetail: "查看详情",
      giveCoin: "赠送金币",
      setSpread: "设为推广员",
      cancelSpread: "取消推广员",
      setAgent: "设为代理员",
      cancelAgent: "取消代理员",
      setNationAdmin: "设为国家管理员",
      cancelNationAdmin: "取消国家管理员",
      setSuperAdmin: "设为超管员",
      cancelSuperAdmin: "取消超管员",
      userNo: "靓号",
      headerImg: "头像",
      nickname: "昵称",
      gender: "性别",
      wealthLevel: "财富等级",
      charmLevel: "魅力等级",
      activeLevel: "活跃等级",
      checkDetail: "查看明细",
      recharge_id: "退款金币数(美金数)",
      notice_time: "最后一次警告时间",
      state: "状态",
      credit1: "账户金币余额",
      recharge_total: "谷歌/苹果充值金额",
      refund_total_money: "累计退款金额",
      create_time: "退款时间",
      order_id: "订单号",
      btnTxt: "用户标签",
      text1: "兴趣",
      text2: "运动",
      text3: "游戏",
      remainingCoins: "金币余额",
    },
    // 活动配置
    activityDeploy: {
      s_search1: "活动ID",
      s_search2: "活动名称",
      s_search3: "查询",
      s_search4: "创建",
      s_search6: "任务ID",
      s_search7: "任务名称",
      s_search8: "普通冲榜",
      s_search9: "充值奖励",
      s_search10: "创建活动",
      s_search11: "编辑活动",
      s_search12: "礼物配置",
      s_search13: "配置成功",
      s_search14: "请输入",
      s_search15: "礼物1",
      s_search16: "礼物2",
      s_search17: "礼物3",
      s_search18: "礼物4",
      s_search19: "请按顺序输入,最少3个",
      s_search20: "是否确认删除活动：",
      s_search21: "活动链接",
      s_search22: "国家管理员选举",
      s_search23: "群PK",
      s_search24: "道具升级",
      s_search25: "记录充值",
      s_search26: "CP活动",
      s_search27: "统计区域",
      s_search28: "全部",
      s_search29: "阿语区",
      s_search30: "英语区",
      s_search31: "国家榜单",
      s_search32: "指定国家",
      s_search33: "关联ID",
      s_search34: "禁止代理上榜",
      s_search35: "送礼人SVIP",
      s_search36: "展示在礼物面板",
      s_search37: "国管活动",
      s_search38: "队伍数量",
      s_search39: "充值门槛",
      s_search40: "收礼人SVIP",
      s_search41: "收礼人性别",
      s_search42: "送礼人性别",
      s_search43: "统计方式",
      s_search44: "禁止BD上榜",
      s_search45: "否",
      s_search46: "互送CP",
      s_search47: "一对一CP",
      s_search48: "黄钻充值",
      s_search49: "金币充值",
      s_search50: "全部充值",
      s_search51: "贵族活动",
      s_search52: "现金赛",
      s_search53: "赛程",
      s_search54: "数据关联",
      s_search55: "现金赛-支持者",
      s_search56: "收票人性别",
      s_search57: "活动循环",
      s_search58: "循环间隔(小时)",
      s_search59: "禁止工会长上榜",
      s_search60: "禁止官方上榜",

      act_table1: "活动ID",
      act_table2: "Banner",
      act_table3: "活动名称",
      act_table4: "活动类型",
      act_table5: "开始时间",
      act_table6: "结束时间",
      act_table7: "其他",
      act_table8: "操作",
      act_table9: "任务配置",
      act_table10: "活动礼物",
      act_table11: "编辑",
      act_table12: "名单下载",
      act_table13: "删除",
      act_table14: "奖励",
      act_table15: "复制",
      act_table16: "投票活动",
      act_table17: "充值统计",
      act_table18: "缩略图",
      act_table19: "活动状态",
      act_table20: "活动备注",
      act_table21: "选手名单",
      act_table22: "待上线",
      act_table23: "在线中",
      act_table24: "已结束",

      act_table25: "128 进 32",
      act_table26: "32 进 16",
      act_table27: "16 进 8",
      act_table28: "8 进 4",
      act_table29: "4 进 2",
      act_table30: "2 进 1"
    },
    bannerManagement: {
      table1Text1: "Banner ID",
      table1Text2: "Banner标题",
      table1Text3: "Banner缩略图",
      table1Text4: "URL",
      table1Text5: "群组ID",
      table1Text6: "排序",
      table1Text7: "上架",
      table1Text8: "下架",
      table1Text9: "新增banner",
      table1Text10: "编辑banner",
      table1Text11: "点击上传缩略图",
      table1Text12: "请上传banner缩略图",
      table1Text13: "上架",
      table1Text14: "下架",
      table1Text15: "确认执行下架操作",
      table1Text16: "确认执行上架操作",
      table1Text17: "跳转类型",
      table1Text18: "群组",
      table1Text19: "上架时间",
      table1Text20: "下架时间",
      table1Text21: "上架时间编辑",
      table1Text22: "礼物栏Banner"
    },

    userReport: {
      search: '搜索',
      warning: '警告',
      banTimeTo: '封禁时间到',
      detail: '详情',
      appQs: 'App问题',
      suggest: '建议',
      topUp: '充值',
      sex: '色情',
      harassment: '骚扰',
      spam: '垃圾信息',
      violationOfLaw: '违法违规',
      other: '其他',
      sureBanUser: '确认解封该用户？',
      ignore: '确认忽略举报信息？',
      sureDelete: '确定删除？',
      unBanSuccess: '解封成功',
      banSuccess: '封禁用户成功',
      permanentBan: '永久封禁',

      tabText1: '用户举报列表',
      tabText2: '违规记录',
      tabText3: '忽略记录',
      resetData: '重置资料',
      banId: '封禁id',
      banDevice: '封禁设备',
      // ignore: '忽略',
      ignore: '检查通过',
      chooseAll: '全选',
      // ignored: '已忽略',
      ignored: '已检查通过',
      reseted: '已重置资料',
      banDeviced: '封禁设备',
      banIdTo: '封禁id ',
      banRoomTo: '封禁房间',
      level: '等级',
      registerIp: '注册IP',
      inTotal: '共有{num}个账号',
      selectAll: '全选',
      topUpReport: '充值举报',
      text: '请输入被举报用户/房主靓号'
    },

    qualityPage: {
      tableText1: "用户ID",
      tableText2: "用户质量总分",
      tableText3: "接通率分值",
      tableText4: "加时率分值",
      tableText5: "接受礼物钻石数量分值",
      tableText6: "接受礼物次数分值",
      tableText7: "魅力等级分值",
      tableText8: "被付费消息次数分值",
      tableText9: "被喜欢次数分值",
      tableText10: "被举报次数分值",
      tableText11: "被拉黑次数分值",
      tableText12: "公户用户分值",
      addTime: "加时率",
      scope: "分",
      time: "次",
      diamon: "钻石",
      connect: "接通率",
      level: "魅力等级"
    },
    eventManagement: {
      tableText1: "座驾ID",
      tableText2: "座驾名称",
      tableText3: "座驾展示图片",
      tableText4: "URL",
      tableText5: "上架",
      tableText6: "下架",
      tableText7: "保存",
      tableText8: "确认下架该座驾",
      tableText9: "确认上架该座驾",
      tableText10: "新增座驾",
      tableText11: "编辑座驾",
      tableText12: "上传座驾图片",
      tableText13: "开始时间",
      tableText14: "结束时间",
      tableText15: "开始时间或结束时间不能为空",
      tableText16: "结束时间不能小于开始时间"
    },
    userInfomation: {
      userId: "ID",
      oId: "原始ID",
      avatar: "头像",
      nickname: "昵称",
      gender: "性别",
      cluster: "群组ID",
      area: "区域",
      gemBalance: "宝石余额",
      beansBalance: "豆子余额",
      tallNobility: "贵族",
      tallNobilityTime: "失效时间",
      createTime: "注册时间",
      connectTotal: "总连接次数",
      effectConnect: "总有效连接次数",
      userScope: "用户分值",
      checkProp: "查看道具",
      setUnionUser: "设为主播",
      unSetUnionUser: "取消主播",
      sendGem: "赠送宝石",
      sendGameMoney: "赠送游戏币",
      seekCluster: "搜索群组",
      connectLog: "连接日志",
      rechargeLog: "充值记录",
      banText: "封禁",
      unUserBanText: "解除用户封禁",
      unDevBanText: "解除设备封禁",
      unDevBanText2: "设备封禁",
      bannedBroadcast: "封禁广播",
      bannedBroadcast1: "解除封禁广播",
      setUnionUserWarn: "是否设为公会用户",
      unSetUnionUserWarn: "是否取消公会用户",
      sendGemTitle: "赠送宝石",
      sendVIP: "赠送VIP",
      sendProps: "赠送道具",
      propsType: "道具类型",
      propsID: "道具ID",
      propsSum: "数量",
      sendVIPTime: "赠送时间",
      sendNBY: "赠送贵族",
      sendNBYRank: "贵族级别",
      sendNBYTime: "有效时间(天)",
      sendDate: "天",
      sendVIPWarn: "天数需要填写正数或最多两位小数",
      // systemRecharge: "系统充值",
      // internalDist: "内部发放",
      // unionUsers: "工会用户发放",
      gemNum: "宝石数量",
      yxbNum: "游戏币数量",
      // actualAmount: "实际金额",
      // sendType: "类型",
      coinType: "币种",
      sendReason: "赠送原因",
      dollar: "美元",
      yuan: "人民币",
      sendGemError1: "宝石数量不能为空",
      sendGemError2: "实际金额不能为空",
      sendGemError3: "赠送原因不能为空",
      sendGemError4: "填写的内容需要为数字",
      unBanUserCheckText: "确认解除封禁",
      unBanUserCheckText1: "确认封禁设备",
      unBanUserCheckText2: "确认解除封禁广播?",
      notDevImei: "没有设备",
      recommend: "在线推荐",
      recommended: "已推荐",
      checkRecomend: "确认执行推荐操作?",
      checkDelete: "确认执行删除推荐操作?",
      resetText: "重置",
      resetAvatarText: "确认执行重置头像操作",
      expensesRecord: "消费记录",
      diamondIncome: "钻石收入记录",
      photoText: "相册",
      photoDelWarn: "确认执行删除操作",
      userDetail: "详情",
      codeId: "靓号id",
      uploadImg: "点击上传头像",
      pageText1: "修改用户昵称",
      pageText2: "修改用户靓号",
      pageText3: "用户靓号",
      pageText6: "修改财富等级",
      pageText7: "修改魅力等级",
      pageText8: "修改活跃等级",
      colorful: "国家炫彩ID",
      pageText4: "确认执行删除该用户靓号id操作",
      pageText5: "该用户没有靓号id",
      groudId: "创建的群组id",
      registerTime: "注册时间",
      lastTimeLogin: "最后一次登录时间",
      memorandum: "运营备忘",
      addMemorandum: "添加运营备忘",
      showMemo: "请输入备忘信息",
      exclusive: "卡券类型",
      exclusiveNum: "卡券个数",
      bobExclusive: "贵族卡券",
      text1: "修改性别",
      text2: "国家",
      text3: "修改国家",
      text4: "查看",
      text5: "冻结消费",
      text6: "消费明细",
      text7: "查看明细",

      text8: "豆子明细",
      text9: "钻石明细",
      text10: "已冻结",
      text11: "确认冻结该帐号消费？",
      text12: "确认解冻该帐号消费？",
      text13: "解冻消费",
      text16: "IP账户",
      text17: "同设备账号数",
      text18: "封禁IP",
      text19: "取消封禁IP",

      broadcastCustodian: "广播管理人",
      addBroadcast: "设为广播管理人",
      delBroadcast: "取消广播管理人",
      addBroadcastCustodian: "是否确认设为广播管理人",
      delBroadcastCustodian: "是否确认取消广播管理人",

      association: "公会名",
      addAssociation: "加入公会",

      identity: "身份",
      setIdentity: "设置国家管理员/助理",
      setIntendantAssistant: "设为国家管理员/助理",
      cancelIntendantAssistant: "取消%s",
      setAssistantFu: "是否确认设为国家管理员/助理身份",
      cancelAssistantFu: "是否确认取消国家管理员/助理身份",
      stateAdministrator: "国家管理员",
      nationalAssistant: "国家助理",

      deleteUnionFu: "是否确认取消主播",

      setIntendant: "设为超级管理",
      unsetIntendant: "取消超级管理",
      haveBeenIntendant: "超级管理身份",
      setIntendantWarn: "是否确认设为超级管理",
      unsetIntendantWarn: "是否确认取消超级管理",
      sendNobility: "赠送贵族",
      quitInfluence: "退出家族",
      unQuitInfluence: "是否确认退出家族",
      deleteProp: "是否确认删除",

      propDetail: "道具详情",
      propType: "道具类型",
      propName: "道具名称",
      propTime: "有效时间",

      nobility: "贵族",
      medal: "勋章",
      headWear: "头饰",
      vehicle: "座驾",
      bagGift: "背包礼物",

      bindingIphone: "绑定手机",
      iphoneText: "请输入绑定手机号",
      bindingPwd: "设置密码",
      pwdText: "请输入密码",
      isWhite: "加入登录白名单",
      birthday: "出生日期",
      createCode: "创建成功",

      income1: "日期",
      income2: "ID",
      income3: "昵称",
      income4: "钻石收入",
      income5: "收入类型",

      daySum: "请输入扣除的天数，输入0则为全部扣除",
      pcsSum: "请输入扣除的个数，输入0则为全部扣除",
      permissionScope: "权限范围",

      cfLevel: "财富等级",
      mlLevel: "魅力等级",
      hyLevel: "活跃等级"
    },
    taskDeploy: {
      act_table1: "任务ID",
      act_table2: "任务名称",
      act_table3: "所属活动",
      act_table4: "任务类型",
      act_table5: "任务触发数值",
      act_table6: "个人送礼梯度奖",
      act_table7: "个人送礼排行",
      act_table8: "个人收礼排行",
      act_table9: "房间送礼排行",
      // act_table10: "1级",
      // act_table11: "2级",
      // act_table12: "3级",
      // act_table13: "4级",
      // act_table14: "5级",
      // act_table20: "6级",
      // act_table21: "7级",
      // act_table22: "8级",
      // act_table23: "9级",
      // act_table24: "10级",
      act_table15: "等级",
      act_table16: "添加成功",
      act_table17: "是否确认删除任务：",
      act_table18: "任务配置奖励列表",
      act_table19: "配置奖励",
      act_table25: "个人充值梯度",
      // act_table26: "11级",
      act_table27: "每张选票获得类型",
      act_table28: "每张选票触发数值",
      act_table29: "选票获得次数",
      act_table30: "个人收到选票排行",
      act_table31: "个人送出选票排行",
      act_table32: "送礼",
      act_table33: "收礼",
      act_table34: "个人收礼梯度奖",
      // act_table35: "个人充值梯度奖",
      act_table36: "道具升级（送礼）",
      act_table37: "CP送礼榜单",
      act_table38: "奖池瓜分-竞选队长",
      act_table39: "奖池数值",
      act_table40: "瓜分人数",
      act_table41: "关联类型",
      act_table42: "个人充值排行",
      act_table43: "用户限制",
      act_table44: "个人送礼排行（日榜）",
      act_table45: "第几天",
      act_table46: "个人送礼梯度-队伍",
      act_table47: "送礼排行-队伍",
      act_table48: "队伍编号",
      act_table49: "队长来源活动",
      act_table50: "队长来源活动任务类型",
      act_table51: "循环周期（天）",
      act_table52: "家族送礼排行",
      act_table53: "家族送礼排行-支持者",
      act_table54: "道具升级（收礼）",
      act_table55: "游戏充值和下注梯度",

      act_table56: "游戏",
      act_table57: "充值门槛",
      act_table58: "水果机",
      act_table59: "下注门槛",

      act_table60: "家族收礼排行",
      act_table61: "家族收礼排行-支持者",
      act_table62: "埃及slot",
      act_table63: " h5游戏-slot",
      act_table64: "群pk勋章升级",
      act_table65: "个人收礼排行-男",
      act_table66: "个人收礼排行-女",
      act_table67: "赛车",
      act_table68: "灵魂伴侣送礼榜单",
      act_table69: "闺蜜送礼榜单",
      act_table70: "兄弟送礼榜单",
      act_table71: "现金队伍奖励",
      act_table72: "个人收礼排行（日榜）",

      level1: "1级",
      level2: "2级",
      level3: "3级",
      level4: "4级",
      level5: "5级",
      level6: "6级",
      level7: "7级",
      level8: "8级",
      level9: "9级",
      level10: "10级",
      level11: "11级",
      level12: "12级",
      level13: "13级",
      level14: "14级",
      level15: "15级",
      level16: "16级",
      level17: "17级",
      level18: "18级",
      level19: "19级",
      level20: "20级",
      level21: "21级",
      level22: "22级",
      level23: "23级",
      level24: "24级",
      level25: "25级",
      level26: "26级",
      level27: "27级",
      level28: "28级",
      level29: "29级",
      level30: "30级",
      level31: "31级",
      level32: "32级",
      level33: "33级",
      level34: "34级",
      level35: "35级",

      award_table1: "ID",
      award_table2: "奖品",
      award_table3: "期限/天",
      award_table4: "数量",
      award_table5: "创建时间",
      award_table6: "金币",
      award_table7: "VIP",
      award_table8: "头饰",
      award_table9: "座驾",
      award_table10: "勋章",
      award_table11: "是否确认删除奖励：",
      award_table12: "道具类型",
      award_table13: "道具ID",
      award_table14: "期限",
      award_table15: "单位",
      award_table16: "数量",
      award_table17: "铭牌",
      award_table18: "盲盒券",
      award_table19: "礼物",
      award_table20: "金币",
      award_table21: "个人飘屏",
      award_table22: "聊天气泡"
    },
    jackpot:{
      tab1:'当前大盘总计',
      tab2:'每日详情查询',
      tab3:'用户详情',
    },
    gameStatistics: {
      game: '游戏',
      area: '区域',
      country: '国家',
      gameAll: '对局总量',
      gameStatus: '对局状态',
      noRun: '无逃跑局',
      openNum: '开局人数',
      peopleNum: '人数占比',
      complateGame: '完成比赛',
      percent: '占比',
      cancel: '主动取消',
      timeOver: '超时取消',
      numText: '数量',
      game2: '2人局',
      game3: '3人局',
      game4: '4人局',
      game5_1: '5人局',
      game6_1: '6人局',
      areaText1: '海湾地区',
      areaText2: '土耳其地区',
      areaText3: '其他地区',
      overGameNum: '完局人数',
      warDrum: '战鼓',
      game5: '2-4人局',
      game6: '5-8人局',
      game7: '9-10人局',

      tableText1:'创建局数',
      tableText2:'完成局数',
      tableText3:'完局率',
    },
    treasureHunt: {
      tabBtn1: '各日对局详情',
      tabBtn2: '对局总计',
      tabBtn3: '玩家用户分析',
      tab2Btn1:'获利TOP100',
      tab2Btn2:'亏损TOP100',
      tab2Btn3:'参与TOP100',
      search1Text1: '日期',
      search1Text2: '对局轮数',
      table1Text1: '日期',
      table1Text2: '对局轮数',
      table1Text3: '参与人数',
      table1Text4: '参与金币数量',
      table1Text5: '中奖人数',
      table1Text6: '中奖总数',
      table1Text7: '期望回收',
      table1Text8: '奖池回收',
      table1Text9: '回收总数',
      table1Text10: '奖池结余金币',
      table1Text11: '结果',

      table2Text1: '日期',
      table2Text2: '对局总轮数',
      table2Text3: '参与人数',
      table2Text4: '参与金币总数',
      table2Text5: '中奖金币总数',
      table2Text6: '期望回收总数',
      table2Text7: '奖池总数',
      table2Text8: '实际回收总数',
      table2Text9: '各选项中奖次数',
      table2Text10: '中奖记录',
      table2Text11: '花费用户ID',
      table2Text12: '花费金额',
      table2Text13: '中奖用户ID',
      table2Text14: '中奖金额',

      table2Text15: '中奖详情',
      table2Text16: '花费详情',
      table2Text17: '榜单奖励总数',
      table2Text18: '榜单奖励详情',


      table3Text1: '花费排行前30名',
      table3Text2: '中奖排行前30名',
      table3Text3: '名次',
      table3Text4: '用户ID',
      table3Text5: '金额',
      table3Text6: '名次',
      table3Text7: '用户ID',
      table3Text8: '金额',
      table3Text11: '下注金额',
      table3Text12: '中奖金币',
      table3Text13: '下注与中奖详情',
      table3Text14: '请输入用户靓号',
      table3Text15: '下注类型',
      table3Text16: '当日盈亏',

      table3Text9: '确认',
      table3Text10: '取消',

      showMore: '查看详情',
      selectText1: '升序',
      selectText2: '降序',
      selectText3: '下注排序',
      selectText4: '中奖排序',
      timeItem: '每轮详情',

      table4Text1: '日期',
      table4Text2: 'TOP奖励',
      table4Text3: '幸运奖励',
      table4Text4: 'TOP1',
      table4Text5: 'TOP1奖励',
      table4Text6: 'TOP2',
      table4Text7: 'TOP2奖励',
      table4Text8: 'TOP3',
      table4Text9: 'TOP3奖励',
      table4Text10: '奖励金额',
      table4Text11: '奖励人数',
      table4Text12: '奖励名单',
      table4Text13: '查看详情',
      table4Text14: '用户id',
      table4Text15: '奖励总额',

      table5Txt1:'等级(财富/魅力/活跃/SVIP)',
      table5Txt2:'本月充值',
      table5Txt3:'当日充值',
      table5Txt4:'金币余量',
      table5Txt5:'参与金币',
      table5Txt6:'中奖金币',
      table5Txt7:'盈亏',

    },
    page401: {
      content: "Oh~~您没有浏览这个页面的权限~"
    },
    page404: {
      content: "Oh~~您的页面好像飞走了~"
    },
    page500: {
      content: "Oh~~鬼知道服务器经历了什么~"
    },
    backBtnGroup: {
      backHome: "返回首页",
      backLast: "返回上一页"
    },
    login: {
      title: "Gama管理系统"
    },
    familyStar: {
      tab1: "自定义称号&榜单数据",
      tab2: "礼物设置",
      tab1text1: "榜单",
      tab1text2: "家族榜",
      tab1text3: "族员榜",
      tab1text4: "榜单类型",
      tab1text5: "称号类型",
      tab1text6: "自定义称号",
      tab1text7: "确认修改？",
      tab1text8: "请输入新的称号",
      tab2text1: "礼物1",
      tab2text2: "礼物2",
      tab2text3: "礼物3"
    },
    jackpotActivities: {
      tab1: "玩法信息",
      tab2: "队伍信息",
      searchText1: "活动序列号",
      newActivityNum: "新增活动序列号",
      language: "语言",
      betStartTime: "下注开始时间",
      betEndTime: "下注结束时间",
      prizeTime: "开奖时间",
      totalGoldCoins: "奖池总金币",
      onceRequiredGoldCoins: "1注金币数",
      teamBetCap: "队伍下注上限",
      winTeamId: "获奖队伍id",
      sponsorDetail: "赞助者详情",
      showLastSeasonTop: "是否展示上赛季TOP",
      ifNeedSponsor: "是否需要赞助",
      betDetail: "下注详情",
      addJackpotActivity: "添加活动",
      editJackpotActivity: "编辑活动",
      selectTime: "选择时间",
      baseGoldCoins: "奖池基础金币",
      addGoldCoins: "奖池新增金币",
      sponsorPercentage: "赞助者百分比",
      betPercentage: "下注百分比",
      ifPrize: "是否开奖",
      setMainPic: "配置头图",
      setSponsorPic: "配置赞助者奖励图片",
      setWinnerPic: "配置胜利者奖励图片",
      setLawText: "配置规则",
      InputResult: "录入赛果",
      sponsorDetailText: {
        sponsorTotal: "赞助者人数",
        coinsTotal: "赞助总金币数",
        sponsorId: "赞助者ID",
        sponsorNum: "赞助者靓号",
        sponsorCoins: "赞助者金币数"
      },
      betDetailText: {
        bettorTotal: "下注人数",
        betTotal: "下注总数",
        bettorId: "下注者ID",
        bettorNum: "下注者靓号",
        betAmount: "下注数",
        teamId: "队伍ID",
        shareBonus: "可瓜分奖金数"
      },
      newTeamInfo: "新增队伍",
      teamId: "队伍ID",
      teamAvatar: "队伍头像",
      teamName: "队伍名称",
      roomId: "房间ID",
      playerId: "选手ID",
      betsUsers: "下注人数",
      betsTotal: "下注总数",
      status: "状态",
      addTeamInfo: "添加队伍",
      editTeamInfo: "编辑队伍",
      undefined: "未定",
      victory: "胜利",
      fail: "失败",

      teamType:'队伍类型',
    },

    theVoice:{
      tab1:'导师列表',
      tab2:'选手列表',
      tab3:'活动配置',

      title1:'新增',
      title2:'编辑',

      btnText1:'新增',

      titleText1:'活动id',
      titleText2:'区域',
      titleText3:'国家',
      titleText4:'赛段',
      titleText5:'活动房间',
      titleText6:'投票开始时间',
      titleText7:'投票结束时间',

      titleText8:'选手昵称',
      titleText9:'选手宣言',
      titleText10:'免费票数',
      titleText11:'礼物票数',
      titleText12:'金币票数',
      titleText13:'选手视频',
      titleText14:'标题',
      titleText15:'总票数',

      formText1:'赛段',
      formText2:'投票开始时间',
      formText3:'投票结束时间',
      formText4:'比赛开始时间',
      formText5:'比赛结束时间',
      formText6:'竞选状态',
      formText7:'票数',
      formText8:'所属战队',
      team_name:'战队名称',

      user_no:'选手id',
      tutorId:'导师id',
      showVideo:'查看视频',
    },

    specialMoment:{
      add:'新建派对',
      theme:'派对主题',
      keep_time:'持续时间',
      leadId:'主角ID',
      groomId:'新郎ID',
      brideId:'新娘ID',
      room_id:'房间ID',

      adminIds:'管理员ID',
      text1:'多个id用英文逗号,隔开',


    },


    championships:{
      tab1:'赛程',
      tab2:'比赛模板',
      tab3:'奖励模板',
      isOff:'下架',
      activityId:'活动id',
      newActivity:'新建比赛',
      newTemplate:'新建模板',

      nickname:'昵称',

      tableText1:'活动主题',
      tableText2:'活动副标题',
      tableText3:'活动类型',
      tableText4:'报名费用',
      tableText5:'报名截止时间',
      tableText6:'报名限额',
      tableText7:'晋级人数',
      tableText8:'开始时间',
      tableText9:'结束时间',
      tableText10:'页面URL',
      tableText11:'创建人',
      tableText12:'地区',
      tableText13:'国家',

      tableText14:'序号',
      tableText15:'用户id',
      tableText15_1:'用户ID / 靓号',
      tableText17:'报名人',
      tableText18:'报名时间',

      tableText19:'排名',
      tableText20:'金币奖励',
      tableText21:'获奖者id',
      tableText23:'编辑人',
      tableText24:'编辑时间',

      tableText25:'赛次',
      tableText26:'比赛房间',
      tableText27:'已分组数量',

      tableText28:'分组号',
      tableText29:'模板ID',
      tableText30:'赛程ID',
      tableText31:'报名审核',

      title1:'新建比赛',
      title2:'编辑比赛',
      title3:'参赛名单管理',
      title4:'分组管理',
      title5:'奖励管理',
      title6:'新建模板',
      title7:'编辑模板',
      title8:'添加分组成员',
      title9:'（共{total}人）',

      titleTip:'如：2强、4强、8强',
      titleTip2:'设置后不可编辑',

      actTypeOpt1:'ludo比赛',

      formText1:'模板风格',
      formText2:'活动主题',
      formText2_1:'活动标题',
      formText3:'赛事时间',
      formText4:'赛事头图',
      formText5:'TOP1奖励图',
      formText5_1:'TOP2奖励图',
      formText5_2:'TOP3奖励图',
      formText6:'活动管理员',
      formText7:'报名要求',
      formText8:'任意等级大于等于',
      formText9:'房间ID',
      formText10:'可填写多个房间靓号id，使用英逗号分开',
      formText11:'可填写多个用户靓号id，使用英逗号分开',
      formText12:'前N强',

      formText13:'分组人数',
      formText14:'方向',

      formText15:'金币奖励',


      signUpList:'报名表',
      raceSchedule:'赛程',
      reward:'奖励',
      editGroup:'编辑分组',

      btnText1:'代报名',
      btnText2:'添加奖励',
      btnText2_1:'修改奖励',
      btnText3:'发放奖励',

      btnText4:'删除所有分组',
      btnText5:'自动随机分组',
      btnText6:'添加分组',

      btnText7:'设置获奖者',
      btnText8:'添加成员',
      btnText9:'分组查看',
      btnText10:'一键导出',
      btnText11:'自动创建2人组',
      btnText12:'自动创建4人组',

      warningText:'点击确认后将清空目前所有的分组信息并重新进行小组分配哦，确定要随机分组的操作吗？',

      errorText:'请选择活动主题',
      errorText2:'上传图片不能超过{size}MB',
      goldError:'请输入奖励金额',
      topError:'请选择父级',
      errorText3:'开始时间不能晚于结束时间',
      errorText4:'所有项目都是必填项',
      errorText5:'有必填项未填写',
      errorText6:'请先选择赛程轮次',

      mianImgText:'尺寸',

      isPrize:'已发放',
      chooseRound:'请选择轮次',

      blackList:'黑名单',


    },

    roomElection:{
      status:'状态',
      batchReject:'批量拒绝',
      roomId:'房间id',
      country:'国籍',
      userId:'房主id',
      screenUrl:'录屏',
      sendVideo:'视频录入',
      passItem:'同意报名',
      rejectItem:'驳回报名',
      warningText1:'确认同意报名',
      warningText2:'确认驳回报名',
      activityId: '活动id'
    },

    roomManagement: {
      bannedt: "封禁时间",
      bannedM: "封禁房间",
      enterRoomId: "请输入房间靓号id",
      roomId: "房间靓号id",
      enterIdInvalid: "输入的id无效",
      notFoundRoom: "未找到该房间",
      // 新增补
      roomName: "房间名称",
      roomHeaderImg: "房间头像",
      roomOwnerId: "房主ID",
      roomOwnerName: "房主昵称",
      roomLevel: "房间等级",
      onlineNum: "在线人数",
      roomLabel: "房间标签管理",
      bgManage: "背景管理",
      auditManage: "审核管理",
      roomOwner: "房主认证",
      showInfo: "查看信息",
      roomLabelText: "房间标签",
      lastMonthAward: "上月奖励",
      monthAward: "本月奖励",
      thisMonthAward: "本月奖励",
      banRoom: "解禁房间",
      unBanRoom: "解除全服封禁",
      banText: "封禁",
      foreverBan: "永久封禁 解禁房间",
      unTop: "点击取消置顶",
      top: "置顶",
      to: "到",
      minute5: "5分钟",
      hour1: "1小时",
      hour12: "12小时",
      setTop: "设置置顶",
      selectTime: "选择日期",
      topStartTime: "置顶开始时间",
      topTime: "置顶时长",
      // 1：2小时 2：4小时 3：6小时 4：24小时
      hour2: "2小时",
      hour4: "4小时",
      hour6: "6小时",
      hour24: "24小时",
      timeOrTypeNotNull: "置顶开始时间或置顶时长不能为空",
      management: "房间管理",
      flowQuery: "房间流水查询",
      roomInfo: "房间信息查询",
      assessment: "房间管理考核",
      supportRoom: "房间扶持审核",
      roomBinding: "房间绑定",
      checkCancelTop: "确认执行取消置顶操作?",
      roomReception: "接待房间设置",
      roomTurntable: "房间转盘",
      text1: "房间支持人",
      text2: "活动订阅人数",
      text3: "专栏名称",
      text4: "已添加活动扶持",
      text5: "添加活动扶持",
      text6: "确认发放活动扶持?",
      text7: "修改上线时间",
      text8: "活动流水",
      text9: "确认添加",
      text10: "会员数",
      text11: "星级等级",
      text12: "房间流水"
    },
    roomDetail: {
      settime: "设置于",
      no: '否',
      receban: "最近封禁记录",
      recedon: "最近冻结记录",
      last_cost_total: "上周流水/总流水",
      heat: "房间热度",
      Admin: "管理员/会员数",
      start: "星级等级",
      RoomRewards: "Room Rewards余额",
      zhiTop: "置顶状态",
      ban: "封禁房间",

      title: "标题",
      content: "内容",
      roomId: "房间靓号",
      notop: "未置顶",
      totop: "置顶",
      roomtext: "房间公告",
      uproomtext: "修改房间公告",
      upRoomstate: "修改置顶状态",
      rmstatetoast: "已经是置顶状态了噢",
      roomName: "房间名称",
      roomImg: "房间头像：",
      bg: "背景图片：",
      expirationDate: "有效期",
      tags: "标签",
      level: "房间等级",
      updateNickname: "修改房间昵称",
      updateNumber: "修改靓号",
      nicknameUnNone: "昵称不能为空",
      //
      sureBanRoom: "确认封禁该房间",
      sureUnbanRoom: "确认解封该房间",
      liftTheBan: "解除封禁",
      chooseTime: "选择封禁时间",
      permanentBan: "永久封禁",
      roomBlacklist: "房间黑名单",
      userId: "用户ID",
      userNickname: "用户昵称",
      deleteUser: "剔除",
      checkDeleteUser: "确定将用户{username}从黑名单中移除吗?",
      checkUpdateLevel: "确认修改等级?",
      levelNoChange: "等级未修改",
      checkUpdateNumber: "确认修改房间靓号?",
      sevenDays: "30天",
      checkSave: "确定保存?",

      seeMedal: "查看勋章",
      medalDetail: "勋章详情",
      addMedal: "新增勋章",

      //
      createdTime: "创建时间",
      roomSupportDetails: "房间扶持明细",
      topTime: "置顶时间",
      country: "国家",
      coins: "金币数",
      releaseTime: "发放时间",
      supportType: "扶持类型",
      userLv: "用户等级(财富/魅力)",
      registrationTime: "注册时间",
      supportStar: "星级扶持",
      supportRoom: "Support 扶持",



    },

    user_data: {
      t1: '金币',
      t2: '座驾',
      t3: '勋章',
      t4: '头饰',
      t5: '礼物',
      t6: '卡券',
      t7: 'vip卡券',
      t8: '飘屏',
      t9: '气泡',
      nid: '用户靓号',
      nick: '用户昵称',
      countrys: '国家',
      leave: '等级',
      priceinfo: '金币余额',
      send_time: '发放时间',
      ztype: '资源类型',
      send_jz: '发送价值',
      send_time: '发送时间',
      send_bz: '发放备注',
      send_type: '发放类型',
      oneSend: '个人发放',
      allSend: '批量发放',
      send_gift: '发放礼物',
      send_prop: '发放道具',
      send_price: '发放金币',
      last_time: '最后登录时间',
      re_time: '注册时间',

      deTime: "操作时间",
      deman: "操作人",
      type: "操作类型",
      donTime: "冻结到期时间",
      donWhy: "冻结原因",

      banok: "封禁",
      banTime: "封禁到期时间",
      banWhy: "封禁原因",
      warnResetUser: "确认执行重置个人信息操作",
      warnBtnText: "警告",
      warnMarkText1: "警告内容",
      warnMarkText2: "警告原因",
      warnMarkText3: "图片",
      warnMarkText4: "所有输入信息不能为空",
      sendErr: "发送退款警告",
      aLink: "复制链接",
      aLinkOk: "复制成功",
      third_order_id: "第三方订单ID",
      title: "标题",
      content: "内容",
      number: "靓号",
      addItem: "新增道具",
      add: "新增",
      setItem: "道具设置",
      endItem: "道具结束",
      headImg: "头像",
      chooseImg: "选择图片",
      clear: "清除",
      nickname: "昵称",
      gender: "性别",
      male: "男",
      confidential: "保密",
      female: "女",
      birthday: "出生日期",
      phone: "手机",
      phoneRegion: "区号",
      email: "邮箱",
      country: "国家",
      province: "省份",
      hobby: "爱好",
      tag: "标签",
      sign: "签名",
      familyName: "家族名称",
      rechargeAmount: "充值金额(元)",
      agentRecharge: "代理充值",
      contribution: "贡献值",
      charmValue: "魅力值(金币)",
      goldCoin: "金币余量",
      diamond: "钻石余量",
      exchange: "钻石兑换金币的钻石总数",
      registerTime: "注册时间",
      equipment: "设备",
      allequipment: "同设备账号",
      text1: "扣除金币",
      registerIp: "注册IP",
      moreIp: "同ip账号",
      lastLoginTime: "最后登录时间",
      monthEarnings: "本月收益",
      lastMonthEarnings: "上月收益",
      createRoomId: "ta创建房间的ID",
      memorandum: "运营备忘",
      addMemo: "添加备忘",
      enterMemoContent: "请输入备忘内容...",
      consumptionAmount: "本次消耗额度",
      remainingQuota: "剩余额度",
      unlimited: "不限额",

      banId: "封禁ID",
      banBroadcast: "封禁广播",
      UnbanBroadcast: "解禁广播",
      clickToBan: "点击封禁",
      banTimeTo: "封禁时间到：",
      permanentBan: "永久封禁",
      ban: "封禁",
      liftTheBan: "解除封禁",
      banEquipment: "封禁设备",
      banGather: "封禁召集",
      unbanGather: "解禁召集",
      banCount: "封禁次数",
      times: "{counts} 次",
      freezeConsumption: "冻结消费",
      freezeing: "正在冻结",
      normal: "正常",
      inMai: "在麦时长",
      level:'等级（财富/魅力）',
      wealthClass: "财富等级",
      charmLevel: "魅力等级",
      activeLevel: "活跃等级",
      banReason: "封禁原因",
      itemType: "道具类型",
      items: "道具",
      aging: "时效(天)",
      numOrDate: "数量or有效时长(天)",
      updateNum: "修改靓号",
      numberId: "靓号id",
      updateNickname: "修改昵称",
      nickname: "用户昵称",
      detailList: "明细列表",
      updatePs: "修改密码",
      vehicle: "座驾",
      medal: "勋章",
      headdress: "头饰",
      number: "靓号",
      VIP: "VIP",
      hasAccount: "共有{num}个账号",
      authentication: "身份认证",
      day: "天",
      gift: "礼物",
      coupon: "卡券",
      roomMedal: "房间勋章",
      sureUpdateImg: "确定修改头像？",
      sureDeleteItem: "确定删除该道具？",
      enterIdInvalid: "输入的id无效",
      enterNoNone: "昵称不能为空",
      enterReason_1: "请填写封禁原因",
      selectReason: "请选择封禁理由",
      selectBanDays: '请选择封禁天数',
      sureBanId: "确定封禁id？",
      sureUnBanId: "确定解除该封禁id？",
      sureBanDevice: "确定封禁设备？",
      sureUnBanDevice: "确定解除该封禁设备？",
      sureUnBanGather: "确定解除该封禁的召集？",
      sureBanGather: "确定封禁召集？",
      sureBanBroadcast: "确定封禁广播？",
      sureUnBanBroadcast: "确定解除该封禁广播？",
      banDuration : "封禁时长",

      useTime:'使用有效期(天)',
      backpackTime:'背包有效期(天)',
      quantity:'数量',


      setTtem: "设置道具",
      // 新增补
      sureUpdatePs: "确定修改密码？",
      psNotNull: "密码不能为空",
      freezeMoney: "冻结消费",
      unFreezeMoney: "解除冻结",
      sureFreeze: "确定冻结消费？",
      sureUnFreeze: "确定解除冻结",
      sureUpdateCounty: "确定修改国家？",
      updatePhoneBind: "更换手机",
      updateMail: "更改邮箱绑定",
      updatePhone: "修改电话号码",
      phoneNum: "电话号码",
      updateMail: "修改邮箱",
      labelMail: "邮箱",
      blockText: "拉黑",
      sureBlock: "确定拉黑？",
      pleaseEnterInfo: "请输入漏单信息",
      missOrder: "漏单信息",
      dayDetail: "退款明细",
      Detailinfo: "充值明细",
      rechargeAmountText: "充值金额",
      rechargeTime: "充值时间",

      chargeType: "充值类型",
      wechat: "微信",
      alipay: "支付宝",
      applyPay: "苹果支付",
      googlePay: "谷歌支付",
      palpay: "palpay支付",

      agentRechargeText: "代理充值",
      agentInternal: "代理内部充值",
      commerceCharge: "电商充值",
      payssion: "payssion支付",
      payoneer: "payoneer",
      deductCoins:'扣币',

      otherPay: "其他支付",
      tapPay: "tap支付",
      huaweiPay: "华为支付",
      payerPay: "茄子快传支付",
      dlocalRecharge: "dlocal充值",
      paypalRecharge: "paypal充值",
      checkoutRecharge: "checkout 充值",

      userNo: "用户靓号",
      agentUserNo: "代理员靓号ID",
      agentHeaderImg: "代理员头像",
      agentNickname: "代理员昵称",
      showItem: "查看道具",
      itemDetail: "道具详情",
      showDetail: "查看详情",
      otherId: "对方靓号",
      typeText: "类型",
      teamTime: "组成关系时间",
      point: "积分",
      showCp: "cp关系",
      cpDetail: "特殊cp关系",
      enterReason: "请填写封禁理由",
      table2Text3: "封禁理由",

      labelTxt1: "标签名称",
      labelTxt2: "标签类别",
      labelTxt3: "排序",
      labelTxt4: "区域",

      labelTxt5: "获得金币数",

      labelTxt6: "兑换钻石数",
      labelTxt7: "注册类型",
      labelTxt8: "解除绑定项",
      labelTxt9: "解绑",
      labelTxt10: "修改身份认证",

      labelTxt11: "用户原始id",
      labelTxt12: "用户id",
      labelTxt13: "用户状态",
      labelTxt14: "认证房间",
      labelTxt15: "认证类型",
      labelTxt16: "已认证",
      labelTxt17: "未认证",

      labelTxt_reason: "认证原因",
      labelTxt18: "认证原因（中）",
      labelTxt19: "认证原因（英）",
      labelTxt20: "认证原因（阿）",
      labelTxt21: "认证原因（土）",
      labelTxt22: "认证原因（印尼）",

      labelTxt23: "认证等级",
      labelTxt24: "消费明细",
      labelTxt25: "消费时间",
      labelTxt26: "消费类型",
      labelTxt27: "金额",
      labelTxt28: "认证原因",
      diamonDe: "钻石明细",
      labelTxt29: "认证原因（葡）",
      labelTxt30: "认证原因（印地）",
      labelTxt31: "认证原因（西）",
      labelTxt32: "认证原因（泰）",
      labelTxt33: "认证原因（越）",
      labelTxt34: "修改区绑定号",
      labelTxt35: "认证开始时间",
      labelTxt36: "认证结束时间",
      labelTxt37: "重置资料",
      labelTxt38: "更换图片",
      labelTxt38_1: "更换图片",
      labelTxt39: "封禁IP",
      labelTxt40: "解禁IP",

      insufficientQuota:'额度不足',

      freeze:'冻结',
      unfreeze:'解冻',
      freezePoint:'冻结点数',
      currentPoint:'当前点数',
      freezeModalTitle:'请输入冻结点数',
      subTitle:'即恶意退款获得的金币数额',
      points:'点数',
      svipFreezeTitleText:'最近操作记录',
      freezeTime:'冻结时间',
      unfreezeMsg:'是否解冻该用户svip',

      notPointText:'请输入冻结点数',

      notSpecialText:'请选择特殊礼物类型',
      notSVIPText:'请选择SVIP等级',




      changeGender:'修改性别',
      chooseGender:'选择性别',
      offcialStatus:'官方身份',

      userNameplate:'个人铭牌',
      addNameplate:'添加铭牌',
    },
    ip_detail: {
      enterUserId: "请输入用户ID",
      userId: "用户id",
      loginTime: "注册时间",
      loginUser: "注册用户",
      loginIp: "注册ip",
      lastLoginTime: "最后登录时间",

      nickname: "昵称",
      deviceCode: "设备码",
      country: "国家",
      wealth: "财富",
      charm: "魅力",
      activeLevel: "活跃等级",
      banAll: "全部封禁",
      banAll_1: "封禁≤5级小号",
      banChooseUser: "封禁所选用户",
      // 新增补
      chooseAll: "全选",
      sureBanUser: "确认封禁用户",

      unBanDevice: "解禁设备",

    },
    moreUserUpList: {
      chooseAll: "全选",
      banAll: "全部封禁",
      banChooseUser: "封禁所选用户",
      choose: "选择",
      sureBanAll: "确认全部封禁",
      enterBanUser: "请选择需要封禁的用户",
      sureBanUser: "确认封禁用户",
      banTimeTo: "封禁时间到",
      permanentBan: "永久封禁",
      enterUserId: "请输入用户ID",
      search: "查询",

      freezeTime:'冻结时间',
    },
    // 新增补
    giving: {
      giveCoin: "赠送金币",
      coinNum: "金币数量",
      actualAmount: "实际金额",
      type: "类型",
      coinType: "币种",
      giftReason: "赠送原因",
      recharge: "系统充值",
      familyEntry: "家族入驻",
      support: "家族扶持",
      award: "活动奖励",
      distribution: "内部发放",
      otherRewards: "其他奖励",
      agentRecharge: "代理充值",
      roomSupport: "房间扶持",
      extRewards: "外管奖励",
      USD: "美金",
      Yuan: "人民币",

      noticeText:'用户信息通知文案',

      notNoticeText:"Please enter the user notification copy",
    },
    roomLabel: {
      labelName: "标签名称",
      color: "颜色",
      label: "标签",
      editLabel: "编辑标签",
      delLabel: "删除标签",
      addLabel: "添加标签",
      modalWarn: "填写标签名或颜色不能为空",
      comfirmDel: "确认删除标签?"
    },
    roomBg: {
      sort: "排序",
      bgImg: "背景图片",
      price: "价格",
      sell: "销售量",
      isOn: "上架",
      isOff: "下架",
      addBg: "添加房间背景",
      bgSmallImg: "背景小图",
      bgBigImg: "背景大图",
      dayTime: "有效时间(天)",
      pleaseDay: "请输入有效时间",
      prize: "价格",
      pleasePrize: "请输入价格",
      saleNum: "销售量",
      pleaseSaleNum: "请输入销售量",
      sort: "排序值",
      pleaseSort: "请输入排序值(数值越大排越前)",
      enterNum: "请填入数字",
      pleaseEnterImg: "请上传背景小图和背景大图",
      checkDelRoomBg: "确认删除房间背景",
      checkOnOperat: "确认执行上架操作",
      checkDownOperat: "确认执行下架操作"
    },
    auditManage: {
      activeAudit: "活动审核",
      bgAudit: "背景审核",
      disband: "房间解散申请",
      passSelectBg: "通过所选背景",
      roomId: "房间号",
      bg: "背景",
      areaSearch: "区域筛选",

      roomIdText: "房间id",
      roomXX: "房主id",
      activer: "活动发起者",
      activeTitle: "活动标题",
      activeContent: "活动内容",
      activeStart: "活动开始时间",
      activeEnd: "活动结束时间",
      activeCreate: "活动创建时间",
      activePoster: "海报底图",
      roomLiangId: "房间靓号",
      status: "状态",
      auditing: "审核中",
      auditPass: "审核通过",
      refused: "被拒绝",
      checkPass: "确认执行通过操作",
      checkRefuse: "确认执行拒绝操作",
      checkDelete: "确认执行删除操作",
      batchPass: "批量通过",
      batchRefuse: "批量拒绝",
      checkBatchPass: "确认执行批量通过操作",
      checkBatchRefuse: "确认执行批量拒绝操作",
      applyDate: "申请日期",
      topText: "置顶",
      topWarn: "确认执行置顶操作",
      unTop: "取消置顶",
      unTopWarn: "确认执行取消置顶操作",
      text1: "是/否专栏 ",
      text2: "专栏名称",
      text3: "活动发起者",
      text4: "房间ID",
      text5: "活动标题",
      text9: "活动内容",
      text6: "活动开始时间",
      text7: "活动结束时间",
      text8: "活动底图"
    },
    auditManageBg: {
      roomLiangId: "房间靓号",
      status: "状态",
      allAudit: "所有审核",
      unAudit: "未审核",
      audited: "已审核",
      roomNum: "房间号",
      roomBg: "背景",
      auditPass: "审核通过",
      refused: "被拒绝",
      checkPass: "确认执行通过操作",
      checkRefuse: "确认执行拒绝操作",
      writeReason: "填写理由",
      checkBatchPass: "确认执行批量通过操作",
      checkBatchRefuse: "确认执行批量拒绝操作",
      batchPass: "批量通过",
      batchRefuse: "批量拒绝",
      toBeAudit:'待审核',
    },
    auditManageDisband: {
      roomId: "房间ID",
      roomName: "房间名称",
      roomImg: "房间头像",
      owerId: "房主ID",
      nickname: "房主昵称",
      level: "房间等级",
      hot: "房间热度",
      currentMonth: "本月流水",
      application: "申请时间",
      roomLiangId: "房间靓号",
      ignore: "忽略",
      dismiss: "解散房间",
      checkIgnore: "确认忽略该房间解散申请",
      checkDismiss: "确认解散该房间",
      ignored: "已忽略",
      dismissed: "已解散",
      text1: "认证时间"
    },
    roomOwner: {
      goldMedal: "金牌",
      silverMedal: "银牌",
      bronzeMedal: "铜牌",
      type: "类型",
      roomLiangId: "房间靓号",
      level: "房间认证等级",
      sort: "排序",
      userLiang: "用户靓号",
      certification: "认证类型",
      symbol: "符号类型",
      equal: "等号",
      rises: "上升",
      falls: "下降",
      addCertification: "添加认证",
      roomCert: "房主认证",
      comfirmIpt: "请填写完整信息",
      checkDelete: "确认执行删除操作"
    },
    roomRunning: {
      enterRoomId: "请输入房间靓号ID",
      startTime: "开始时间",
      endTime: "结束时间",
      export: "导出",
      editRoom: "编辑监控房间",
      allCountry: "全部国家/地区",
      pleaseEnter: "请输入国家/地区",
      country: "国家",
      roomHot: "房间热度(0-0.1K)",
      roomHot2: "房间热度(0.1-0.5K)",
      roomHot3: "房间热度(0.5-1K)",
      roomHot4: "房间热度(1-2K)",
      roomHot5: "房间热度(2-5K)",
      roomHot6: "房间热度(5K以上)",

      time: "时间",
      roomOwner: "房主ID",
      createTime: "创建时间",
      roomLevel: "房间等级",
      nowHot: "当前热度",
      totalCoin: "总流水(金币)",
      todayCoin: "当天流水(金币)",
      showDetail: "查看详细",
      sendCoin: "发放金币",

      hourlyFlow: "整点流水",

      hourlyFlowT1: "时间段",
      hourlyFlowT2: "当前流水"
    },
    // 活动扶持
    activitiesSupport: {
      pageName: "活动扶持管理",
      text1: "未完成扶持",
      text2: "活动后扶持",
      text3: "已完成扶持",
      text4: "已拒绝",
      text5: "房间id",
      text6: "房主id",
      text7: "活动标题",
      text8: "活动内容",
      text9: "房间热度",
      text10: "支持人数",
      text11: "本周扶持次数",
      text12: "累计扶持次数",
      text13: "上场流水",
      text14: "本场流水",
      text15: "本场扶持金币数",
      text16: "奖励礼物",
      text17: "活动开始时间",
      text18: "活动结束时间",
      text19: "活动创建时间",
      text20: "专栏名称",
      text21: "状态",
      text22: "国家",
      text23: "同意扶持",
      text24: "拒绝扶持",
      text25: "修改扶持方案",
      text26: "是否发放扶持",
      text27: "是否拒绝发放扶持",
      text28: "修改扶持方案",
      text29: "扶持方案列表",
      text30: "录屏",
      text31: "查看录屏",
      text32: "本周扶持次数已超过2次，建议不发放扶持奖励",
      text33: "房间认证",
      text34: "星级房间管理",
      text35: "星级认证记录",
      text36: "星级房间扶持记录",
      text37: "批量发放",
      text38: "批量拒绝",
      text39: "黑名单",
      text40: '房间星级认证',
      text41:'拒绝并删除',
      text42:'是否删除？删除后，用户可以再次申请扶持。',

    },
    // 房间扶持
    roomSupport: {
      enterRoomId: "请输入房间靓号id",
      num: "序号",
      roomId: "房间ID",
      roomOwnerId: "房主ID",
      roomFollow: "房间累计流水",
      lastWeek: "上周流水",
      hot: "热度",
      supportAdmin: "扶持管理员",
      supportText: "扶持标准",
      supportLevel: "扶持等级",
      peopleNum: "当前人数/人数限制",
      totalNum: "累计扶持次数",
      createTime: "添加时间",
      sendTime: "最后发放时间",
      roomOwner: "房主",
      roomAdmin: "管理员",
      roomInfo: "房间信息",
      roomAvatar: "房间头像",
      ownerId: "房主ID",
      totalSupport: "累计扶持",
      roomHot: "房间热度",
      roomTotal: "房间总流水",
      award: "奖励标准",
      adminId: "管理员ID",
      adminAtLeast10: "管理员至多10名",
      adminAtLeast1: "管理员至少1名",
      sendText: "发放",
      checkSend: "确定发放吗?",
      checkDel: "确定删除吗?",
      addRoom: "新增房间",
      exportExcle: "导出Excle",
      enterRoomId2: "输入房间id",
      chooseSend: "选择发放",
      chooseSendmsg: "请选择发放对象",
      checkSendTarget: "确认发放给选择对象",
      checkSendCoin: "该房间距离上次发放时间不超过6天,确认发放",
      text1: "方案列表",
      text2: "地区",
      text3: "方案标识",
      text4: "等级",
      text5: "方案名称",
      text6: "奖励",
      text7: "类型",
      text8: "修改扶持方案",
      text9: "新增扶持方案",
      text10: "1星",
      text11: "2星",
      text12: "3星",
      text13: "领奖者ID",
      text14: "未发放列表",
      text15: "应发房间靓号",
      text16: "应发时间",
      text17: "应发用户靓号",
      text18: "未成功发放原因",
      3: "房间距离上次发放时间不超过6天",
      4: "房间已被封禁不允许发放",
      5: "房间房主已被封禁不允许发放",
      6: "房间没有满足的扶持标准",
      7: "房间不属于任何一个等级",
      8: "房主是主播",
      9: "成员是主播",
      10: "成员是越南语 、泰语、西语 、印尼语、葡萄牙语几个区域用户",
      11: "房主有待审核或通过的房间认证扶持跳过对整个房间的扶持",
      12: "成员是房间认证系统中的管理员跳过房间扶持",
      13: "房主是房间认证系统中的管理员跳过房间扶持",
      14: " 成员已经不是管理员 ",
      15: "成员在其他房间扶持 ",
      16: "会员被封禁",
      17: "会员被冻结消费 ",
      18: "房间已在app端领取扶持",
      19: "ip/设备超上限",

      //
      giftWorth: "礼物价值",




    },
    roomManagementCheck: {
      roomId: "房间靓号ID",
      roomName: "房间名称",
      adminId: "管理员ID",
      adminName: "管理员昵称",
      enterTime: "进入时间",
      leaveTime: "离开时间",
      servingTime: "上麦时长(分钟)",
      unLeave: "未离开"
    },
    roomBind: {
      addBind: "添加绑定",
      roomId: "房间id",
      inviteUser: "邀请用户id",
      weekCost: "本周流水",
      lastWeekCost: "上周流水",
      roomCreateTime: "房间创建时间",
      roomBindTime: "房间绑定时间",
      roomUserNotNull: "房间靓号或用户靓号不能为空"
    },
    roomRunningDetail: {
      inpUrl: "url",
      export: "导出",
      sendCoin: "发放金币",
      enterCoin: "输入金币",
      roomId: "房间靓号",
      roomName: "房间名称",
      roomOwnerId: "房主靓号ID",
      roomNickname: "房主昵称",
      createTime: "房间创建时间",
      level: "房间等级",
      country: "国家",
      peakNumber: "峰值",
      nowHot: "当前热度",
      totalCoin: "总流水(金币)"
    },
    roomListening: {
      addRoom: "添加1个房间",
      editTime: "编辑监控起始时间",
      addTime: "添加监控房间",
      roomId: "房间靓号",
      roomName: "房间名称",
      level: "等级",
      roomOwnerId: "房主ID",
      roomNickname: "房主昵称",
      startTime: "监控起始时间",
      checkDel: "确认删除?",
      pleaseEnter: "请填写房间靓号",
      batchUpload: "批量上传"
    },
    RoomReception: {
      tableText1: "地区",
      tableText2: "房间ID",
      tableText3: "房主ID",
      tableText4: "开始日期",
      tableText5: "结束日期",
      tableText6: "接待人数",
      tableText7: "设置人",
      tableText8: "设置时间",
      tableText9: "开始",
      tableText14:'优先接待国家',
      formText1: "房间ID",
      formText2: "开始时间",
      formText3: "结束时间",
      formText4: "区域",
      tableText10: "房间",
      tableText11: "日期",
      tableText12: "接待人数",
      tableText13: "次留",
      formText5: "新建",
      btnText1: "详情",
      btnText2: "开始",
      btnText3: "暂停",
      addRoomWarn: "未填写完整",
      checkDel: "确认删除这条房间接待?",
      addRoomTitle: "新增房间接待",
      editRoomTitle: "编辑房间接待"
    },
    roomTurntable: {
      tableText1: "奖品ID",
      tableText2: "奖品名称",
      tableText3: "奖品类型",
      tableText4: "价值",
      tableText5: "过期时间(卡卷礼物)",
      tableText6: "有效时长",
      tableText7: "当前数量",
      tableText8: "日均临界数量",
      tableText9: "奖品概率",
      tableText10: "状态",
      tableText11: "是否公屏",
      addAward: "新增奖品",
      typeText1: "卡卷类",
      typeText2: "礼物类",
      typeText3: "金币类",
      typeText4: "道具类",
      typeText5: "座驾类",
      typeText6: "头饰类",
      isOnText1: "已上架",
      isOnText2: "未上架",
      select1Type1: "座驾",
      select1Type2: "卡卷",
      select1Type3: "头饰",
      select1Type4: "礼物",
      select1Type5: "金币",

      formText1: "奖品类型",
      formText2: "单价(/金币)",
      formText3: "奖品内容",
      formText4: "有效时长(天)",
      formText5: "存放有效期(天)",
      formText6: "当前数量",
      formText7: "日均临界数量",
      formText8: "奖品概率",
      formText9: "展示图标",
      formText10: "是否上架",
      formText11: "是否推送",
      formText12: "是否上滚动",
      formText13: "是否是大奖",
      formText14: "抽中后",
      formText15: "大于0的整数",
      formText16: "次内不会再中奖",
      formText17: "不中大奖时该奖品概率为",

      addTurnWarn: "展示图标未必填",
      addAwarnTitle: "新增奖品",
      editAwardTitle: "编辑奖品",
      upStatus1: "上架",
      upStatus2: "下架",
      upWarnText1: "确认执行上架操作",
      upWarnText2: "确认执行下架操作",
      deleteWarn: "确认执行删除操作",
      tabText1: "奖池设置",
      tabText2: "统计查询",

      statisticsText1: "中奖统计",
      statisticsText2: "抽奖统计",
      statisticsText3: "状态",
      statisticsText4: "筛选",
      statisticsText5: "日期",
      statisticsText6: "奖池ID",
      statisticsText7: "日期",
      statisticsText8: "奖品名称",
      statisticsText9: "中奖次数",
      statisticsText10: "中奖价值",

      statisticsText11: "日期",
      statisticsText12: "总抽奖人数",
      statisticsText13: "总抽奖次数",
      statisticsText14: "金币次数",
      statisticsText15: "消耗总金币"
    },
    pageAd: {
      addAd: "新增广告",
      uped: "已上架",
      waitUp: "待上架",
      downed: "已下架",
      down: "下架",
      up: "上架",
      adKeyword: "广告名称关键字",
      adStatus: "广告状态",
      unUp: "未上架",
      hasDown: "已下架",
      adId: "广告ID",
      upTime: "上架时间",
      adTitle: "广告标题",
      upArea: "上架地区",
      imgThum: "图片缩略图(英语)",
      // imgSmall: "图片浏览(英语)",
      imgSmall: "图片预览",
      sort: "排序",
      status: "状态",
      minute5: "5分钟",
      hour1: "1小时",
      hour2: "2小时",
      hour12: "12小时",
      checkDel: "确定删除?",
      checkDown: "是否下架该广告",
      checkUp: "是否上架该广告"
    },
    adDetail: {
      adInfo: "首页Banner",
      spreadwd: "开屏弹窗",
      activityTitle: "活动标题",
      jumpRoom: "跳转房间",
      shareContent: "分享内容",
      thum: "缩略图",
      adImg: "广告图片",
      sort: "排序",
      upArea: "上架地区",
      upTime: "上架时间",
      downTime: "下架时间",
      aArea: "阿语地区",
      tArea: "土耳其语地区",
      yArea: "印尼语地区",
      oArea: "英语",
      area5: "越南语",
      area6: "泰语",
      area7: "印地",
      area8: "西语",
      saveCreate: "保存并创建关联广告",
      saveCreate1: "保存并创建关联",
      saveCreate2: "保存并创建关联"
    },
    operationalPopup: {
      popup: "登录弹窗",
      tableText1: "弹窗标题",
      tableText2: "弹窗内容",
      tableText3: "图片",
      tableText4: "地区",
      tableText5: "对象",
      tableText6: "时间",
      object0: "全部",
      object1: "大于",
      object2: "小于",
      object3: "等于",
      object4: "财富等级大于",
      object5: "财富等级小于",
      object6: "财富等级等于",
      object7: "魅力等级大于",
      object8: "魅力等级小于",
      object9: "魅力等级等于",
      object10: "活跃等级大于",
      object11: "活跃等级小于",
      object12: "活跃等级等于",

      formText1: "弹窗图片",
      formText2: "类型(跳转)",
      formText3: "话题ID/帖子ID",
      formText4: "URL",
      formText5: "房间ID",
      formText6: "下发语言区",
      formText7: "下发国家",
      formText8: "对象等级",
      formText9: "是否只对新用户可见",
      formText10: "每天上架时间",
      formText11: "每天下架时间",
      formText12: "上架时间",
      formText13: "下架时间",
      formText14: "对象",
      chooseImg: "选择图片",
      clear: "清除",

      addPopup: "添加运营弹窗",
      updatePopup: "修改运营弹窗",

      typeSelect1: "不跳转",
      typeSelect2: "充值",
      typeSelect3: "房间",
      typeSelect4: "H5",
      typeSelect5: "帖子",
      typeSelect6: "话题",
      typeSelect7: "用户",
      typeSelect8: "房间活动",
      typeSelect9: "群详情",
      allOrNull: "全选/全不选",
      selectOther: "反选",
      deletePopup: "确认删除该运营弹窗?",

      text1: "开屏弹窗",
      text2: "开屏ID",
      text3: "开屏备注",
      text4: "上架地区",
      text5: "图片预览",
      text6: "跳转URL",
      text7: "排序",
      text8: "操作",
      text9: "广告备注",
      text10: "弹窗图片",
      text11: "跳转类型",
      text12: "话题ID/帖子ID",
      text13: "URL",
      text14: "房间ID",
      text15: "用户ID",
      text16: "展示语区",
      text17: "",
      text18: ""
    },
    operationLog1: {
      1: "用户信息查询",
      2: "房间管理",
      3: "家族信息查询",
      4: "广告信息查询",
      5: "礼物信息查询",
      6: "管理员账号设置",
      7: "角色权限管理",
      8: "金币发放管理",
      9: "操作日志",
      10: "超级管理员",
      11: "系统消息管理",
      12: "密码管理",
      13: "活动管理",
      14: "道具商城",
      15: "国家管理",
      16: "设置",
      17: "用户举报",
      18: "主持管理",
      19: "代理管理",
      20: "专题房间推荐",
      21: "敏感词管理",
      22: "房间水晶",
      23: "开发人员管理",
      24: "房间监控",
      25: "房间扶持"
    },
    operationLog2: {
      1: "用户信息查询",
      2: "房间管理",
      3: "家族信息查询",
      4: "广告信息查询",
      5: "礼物信息查询",
      6: "管理员账号设置",
      7: "角色权限管理",
      8: "金币发放管理",
      9: "操作日志",
      10: "超级管理员",
      11: "系统消息管理",
      12: "密码管理",
      13: "活动管理",
      14: "道具商城",
      15: "国家管理",
      16: "设置",
      17: "用户举报",
      18: "主持管理",
      19: "代理管理",
      20: "专题房间推荐",
      21: "敏感词管理",
      22: "房间水晶",
      23: "开发人员管理",
      24: "房间监控",
      25: "房间扶持",
      26: "角色权限管理",
      27: "管理员账号设置",
      28: "违规用户管理",
      29: "房间专栏",
      30: "客服后台",
      31: "邀请管理"
    },
    operationLog3: {
      1: "赠送金币",
      2: "设为超管员",
      3: "取消超管员",
      4: "设置代理员",
      5: "取消代理员",
      6: "设置国家管理员",
      7: "取消国家管理员",
      8: "修改靓号",
      9: "新增道具",
      10: "删除道具",
      11: "修改道具",
      12: "修改头像",
      13: "修改昵称",
      14: "修改国家",
      15: "扣除金币",
      16: "修改密码",
      17: "修改绑定手机号",
      18: "修改绑定邮箱",
      19: "解除绑定",
      20: "封禁id",
      21: "解禁id",
      22: "封禁设备",
      23: "解禁设备",
      24: "冻结消费",
      25: "解冻消费",
      26: "财富等级",
      27: "魅力等级",
      28: "活跃等级",
      29: "修改身份认证3",
      30: "设为推广员",
      31: "取消推广员",
      32: "背景审核通过",
      33: "背景审核拒绝",
      34: "活动审核通过",
      35: "活动审核拒绝",
      36: "删除活动",
      37: "封禁房间",
      38: "解禁房间",
      39: "修改房间基本信息",
      40: "移除房间黑名单",
      41: "置顶房间",
      42: "取消置顶房间",
      43: "添加/修改房间标签",
      44: "删除标签",
      45: "添加/修改房间背景",
      46: "删除房间背景",
      47: "上架/下架",
      48: "房间认证",
      49: "删除房间认证",
      50: "添加房间绑定",
      51: "审核房间解散申请",
      52: "修改",
      53: "删除",
      54: "添加",
      55: "重置资料",
      56: "拉黑用户IP",
      57: "保存礼物信息",
      58: "保存表情",
      59: "取消道具出售",
      60: "保存道具信息",
      61: "删除卡券",
      62: "删除区域礼物",
      63: "扣除钻石",
      64: "忽略",
      65: "通过",
      66: "拒绝",
      67: "发放扶持金币",
      68: "置顶",
      69: "确认付款",
      70: "代理充值",
      71: "身份认证",
      72: "解除绑定",
      73: "锁定",
      74: "回复"
    },
    operationLogPage: {
      userId: "用户靓号",
      roomId: "房间靓号",
      startTime: "开始时间",
      endTime: "结束时间",
      model: "模块",
      table1: "创建时间",
      table2: "类型",
      table7: "管理员id",
      table3: "操作详情",
      table4: "操作原因",
      table5: "备注信息",
      table6: "操作人",
      table8: "操作时间",
      table9: "扣除时间"
    },
    itemsMall: {
      deleteAreaPorp: "删除区域道具",
      checkDelAreaPorp: "确认删除区域道具?",
      enterGift: "请输入道具名称",
      keyword: "关键字",
      addItem: "添加道具",
      downing: "下架中",
      uping: "上架中",
      canSell: "可以售卖",
      canNotSell: "不可以售卖",
      down: "下架",
      up: "上架",
      cancelSell: "取消出售",
      setSell: "设置出售",
      userList: "用户名单",
      itemName: "道具名称",
      classificat: "分类",
      upDown: "上/下架",
      inOutSale: "状态",
      car: "座驾",
      middle: "勋章",
      headwear: "头饰",
      liangId: "靓号",
      upDownText: "上架&下架",
      inOutSaleText: "在销&停销",
      inSale: "在销",
      outOfSale: "停销",
      itemIcon: "道具展示图标",
      effectTime: "有效时间(天)",
      isUp: "是否上架",
      isSale: "是否售卖",
      createTime: "创建时间",
      checkDelItem: "确定删除该道具?",
      checkDownItem: "是否下架该商品?",
      checkUpItem: "是否上架该商品?",
      checkSetSale: "是否设置出售",
      checkCancelSale: "是否取消出售",
      languageArr: "语言区",
      userListBtn: "发送道具",
      userRole: "使用者名单",
      userId: "用户ID",
      userNickname: "用户昵称",
      getTime: "获得时间",
      effectTime: "时效时间",
      prices: '价格',
      regions: '区域',
      addUser: "添加用户",
      effectDay: "时效(天)",
      enterNum: "请输入数字",
      enterUserIdNotNull: "输入用户id不能为空且为数字",
      enterDayNotNull: "输入的天数不能为空且为数字",
      checkDeleteUser: "确认删除该用户?",
      use_number: "用户使用人数",
      text1: "Vip卡卷",
      text2: "非vip卡卷",
      text3: "道具数量(时长)",
      text4: "道具单价",
      text5: "道具总价",
      text6: "个人飘屏",
      text7: "非vip卡卷",
      text8: "非vip卡卷",
      text9: "特殊关系卡",
      text10: "聊天气泡",
      text11: "特殊关系卡类型",
      text12: "无",
      text13: "Special_CP",
      text14: "forever friend",
      text15: "Close friend ",
      text16: "席位卡",
      text17: "解除关系卡"
    },
    itemDetail: {
      giftInfo: "礼物信息",
      itemName: "道具名称",
      itemType: "道具类型",
      itemIcon: "道具展示图标",
      iconSmall: "小图标",
      showIcon: "商城展示图标",
      grayIcon: "灰度图标",
      price: "价格",
      itemEffect: "道具特效",
      chooseFile: "选择文件",
      effectTime: "有效时间(天)",
      checkUp: "是否是上架",
      checkSale: "是否售卖",
      checkLimitSale: "是否限售",
      autoGet: "自动获取",
      country: "国家",
      middleName: "勋章名称",
      middleType: "勋章类型",
      none: "无",
      middle1: "pk勋章",
      middle2: "房间王勋章",
      middle3: "情圣勋章",
      middle4: "情后勋章",
      middle5: "周情侣勋章",
      middle6: "周星勋章",
      middle7: "国家荣誉勋章",
      middle8: "国家特别勋章",
      middle9: "国家星耀",
      middle10: "国家星钻",
      middle13: "26级等级勋章",

      middle11: "27级等级勋章",
      middle12: "StarsForAll勋章",
      middle14: "LoveForAll勋章",
      middle15: "个人粉丝",
      middle16: "房间关注",
      middle17: "房间置顶",
      middle18: "充值勋章 ",
      middle19: "新充值勋章",
      middle20: "水果机勋章",
      middle22: "荣誉勋章",
      middle23: "荣誉勋章",
      middle24: "成就勋章",
      middle25: "荣誉勋章",
      middle26: "送礼勋章",
      middle27: "收礼勋章",
      middle28: "房间转盘勋章",
      middle29: "幸运盒子勋章",
      middle30: "StarsForAll礼物",
      middle31: "LoveForAll礼物",
      middle32: "首充勋章",
      middle33: "推广员勋章",
      middle34: "送出 Moon for all 勋章",
      middle35: "收到 Moon for all 勋章",
      middle36: "Teenpatti勋章",
      middle37: "推广充值勋章",
      middle38: "美食家游戏勋章",
      middle39: "jackpot勋章",
      middle40: "Candy勋章",
      middle41: "冻结技能勋章",
      middle42: "禁言技能勋章",
      middle43: "小丑技能勋章",
      middle44: "救援技能勋章",
      middle45: "SuperCar勋章",

      car: "座驾",
      middle: "勋章",
      headware: "头饰",
      liangId: "靓号",
      roomMedia: "房间勋章",
      eArea: "英语",
      aArea: "阿语",
      yArea: "印尼语",
      tArea: "土耳其语",
      allArea: "全区",
      region: "区域",
      addItem: "添加道具",
      updateItem: "修改道具",

      languageText1: "土耳其语",
      languageText2: "非土耳其语",
      languageText3: "越南",
      languageText4: "泰国",
      languageText5: "印地语",

      text1: "是否配置勋章奖励",
      text2: "跳转地址",
      text3: "勋章展示图片",

      ifSVIP:'是否SVIP专属',
    },
    // 销售列表
    saleList: {
      itemType: "道具类型",
      car: "座驾",
      media: "勋章",
      headware: "头饰",
      liangId: "靓号",
      upDown: "上架&下架",
      down: "下架",
      up: "上架",
      inOutSale: "在销&停销",
      inSale: "在销",
      outSale: "停销",
      itemName: "道具名称",
      price: "单价",
      saleNum: "销售量",
      saleMoney: "销售额"
    },
    itemCoupon: {
      addCoupon: "新增卡券",
      couponName: "卡券名称",
      price: "单价",
      showImg: "展示图片",
      effectTime: "有效期",
      addTime: "添加时间",
      price2: "价格",
      type: "类型",
      couponIcon: "卡券展示图标",
      itemEffect: "道具特效",
      effectTimeDay: "有效时间(天)",
      delCoupon: "确认删除该卡券?"
    },
    // 礼物信息查询
    giftInformation: {

      pageGift1: "礼物管理",
      shelves: "上架",
      offShelf: "下架",
      detail: '发放明细',
      bringShelf: "即将上架",
      beenOn: "已上架",
      beenOff: "已下架",
      giftId: "礼物ID",
      giftInformation: "礼物信息",
      giftName: "礼物名称",
      giftBigIcon: "礼物列表图标",
      bigThumb: "big_thumb图",
      giftSmallIcon: "资料页图标",
      keyword: "请输入礼物名称关键字搜索",
      gold: "金币",
      diamond: "钻石",
      state: "状态",
      rackOrder: "架上排序",
      operation: "操作",
      time1: "5分钟",
      time2: "1小时",
      time3: "2小时",
      time4: "12小时",
      onShelves: "是否上架该商品",
      offShelves: "是否下架该商品",
      query: "查询",
      newGift: "新增礼物",
      editor: "编辑",
      chooseImg: "选择图片",
      clear: "清除",
      special: "礼物特效",
      chooseFile: "选择文件",
      giftEffectsFile: "礼物特效文件",
      isEventGift: "是否是活动礼物",
      anyMusic: "是否有音乐",
      enterText: "是否可输入文字",
      outputDiamond: "产出钻石",
      toastTxt:
        "注意：此处显示的是钻石产出默认值，为输入消耗值的30%，请不要随意修改该值。银币礼物默认钻石返点为0",
      isShelf: "是/否上下架",

      shelfRegion: "上架地区",
      shelfTime: "上架时间",
      frameTime: "下架时间",
      toastText: "  注意：用英文,分开",
      arabicArea: "阿语地区",
      TRArea: "土耳其语地区",
      inArea: "印尼语地区",
      other: "其他(英语)",

      expressionInformation: "表情信息",
      expressionManagement: "表情管理",
      emojiEffects: '表情特效',
      emojiEffectsFile: '表情特效文件',
      selectRegion: "地区",
      shelfOrder: "上架顺序",
      copyToOtherRegion: "复制到其他区",
      selectTargetRegion: "选择目标区域",

      eKeyword: "请输入表情名称关键字搜索",
      eId: "表情ID",
      eName: "表情名称",
      eImag: "表情图标",
      all: "全部",
      newExpression: "新增表情",
      remark: "备注",
      btnBox1: "普通礼物",
      btnBox2: "特殊礼物",
      btnBox3: "国家礼物",
      btnBox4: "冠名礼物",
      btnBox5: "浪漫礼物",
      btnBox6: "SVIP礼物",
      selectOpt1: "普通",
      selectOpt2: "特殊",
      selectOpt3: "国家",
      selectOpt4: "冠名",
      selectOpt5: "浪漫",
      selectOpt6: "SVIP",
      upArea: "已上架地区",
      giftAdd: "礼物添加",
      areaText: "地区",
      selectText: "分栏",
      sortText: "排序",
      sortText_1: "架上排序(倒序)",
      sortText_2:'商城排序(倒序)',
      sortText_3:'商城排序',
      setArea: "设置分区",
      updateArea: "修改分区",
      giftUpdate: "礼物修改",
      enterNum: "请输入数字",
      enterAreaNoNull: "地区不能为空",
      enterNoNull: "填写内容不能为空",
      userListBtn: "用户列表",
      languageArr: "语言区",
      selectReOpt1: "土耳其语地区",
      selectReOpt2: "其他(非土耳其语地区)",
      remarkSelect: "备注(选填)",
      isSpecial: "是否是特殊关系礼物",
      cpText: "cp",
      friendText: "forever&close",

      bindUserId: "绑定用户ID",
      deleteAreaGift: "删除区域礼物",
      checkDelAreaGift: "确认删除区域礼物?(删除后可在“全部”区域重新设置分区)",
      prizeTxt: "价格区间",

      text1: "分区名称(礼物库名称)",
      text2: "定制礼物用户id",
      text3: "分区名称(道具库名称)",

      price_rang_5000: "5000及以上",
      price_rang_all: "全部",

      copySuccessInfo:'已成功复制到指定区域的下架tab',

      giftType:'礼物类型',
      SVIP:'SVIP礼物',

      specialGiftType:'特殊礼物类型',
      svipLevel:'SVIP等级',

      ifSVIPface:'是否svip表情',

      svipFace:'SVIP表情',

      giftPartitionCount:'当前上架礼物总数',


      saleTime:'上架时间',
      offsaleTime:'下架时间',


    },
    //家族信息查询
    familyInformation: {
      batchkickout: "批量踢出",
      keyStr: "请输入家族id",
      query: "查询",
      newFamily: "创建家族",
      editor: "编辑",
      viewFamily: "查看家族成员",
      dissolutionFamily: "解散家族",
      keyword: "家族id",
      familyId: "家族id",
      familyName: "族名",
      familyOwner: "族长",
      familyOwnerid: "族长ID",
      familyPortrait: "家族头像",
      membership: "成员人数",
      familyLevel: "家族等级",
      wealthLeave: "财富等级",
      charmLeave: "魅力等级",
      incomeBate: "分成比例",
      incomeToday: "今日家族收益(元)/流水(元)",
      incomeMonth: "本月家族收益(元)/流水(元)",
      incomeLastMonth: "上月家族收益(元)/流水(元)",
      incomeCount: "总家族收益(元)/流水(元)",
      confirmOne: "确定解散该家族?",

      familyList: "家族成员列表",
      memberId: "请输入成员靓号id",
      outFamily: "踢出家族",
      NmemberId: "成员id",
      F_memberId: "家族成员靓号ID",
      memberNickname: "成员昵称",
      gender: "性别",
      memberHead: "成员头像",
      cToday: "今日贡献(钻石)",
      cMonth: "本月贡献(钻石)",
      toast1: "确认将改成员提出家族？",

      familyInformation: "家族信息",
      familyDeclaration: "家族宣言",
      starFamily: "是否为星际家族",
      proportion: "分成比例",
      between: "百分比：请输入0-100之间的数值",
      notNull: "*不能不空",
      memberIds: "5个创始成员ID",
      noMember: "成员不足",
      familyNameNotNull: "族名不能为空",
      createdIdNotNull: "族长id不能为空",
      avatarNotNull: "家族头像不能为空",
      reportNotNull: "家族宣言不能为空",
      rateNotNullOrNum: "分成比例不能为空或应为数字",
      dissolutFamily: "解散家族申请"
    },
    familyDissolution: {
      familySearch: "家族查询",
      dissolution: "家族解散申请",
      familyId: "家族ID",
      familyName: "族名",
      familyImg: "家族头像",
      ownerId: "族长ID",
      nickname: "族长昵称",
      level: "家族等级",
      starLevel: "家族星级",
      number: "成员数",
      addTime: "申请时间",
      dissolutioned: "已解散",
      ignore: "忽略",
      ignored: "已忽略",
      dissolutionFam: "解散家族",
      checkDissolut: "确认执行解散房间操作",
      checkIgnore: "确认执行忽略操作",
      text: "待审核"
    },
    superTube: {
      liangNick: "靓号ID",
      cancelAdmin: "取消超级管理员",
      liangKey: "靓号id",
      liangId: "靓号ID",
      avatar: "头像",
      nickname: "昵称",
      country: "国家",
      lastLogin: "上次登录",
      checkCancelAdmin: "确定取消超管员吗?"
    },
    national: {
      liangNick: "靓号ID",
      cancelNation: "取消国家管理员",
      liangKey: "靓号id",
      liangId: "靓号ID",
      avatar: "头像",
      nickname: "昵称",
      country: "国家",
      lastLogin: "上次登录",
      checkCancelNation: "确定取消国家管理员吗?"
    },
    // 敏感词管理
    sensitiveWords: {
      keyword: "关键字",
      newSensitiveWords: "新增敏感词",
      record: "记录",
      drecord: "不记录",
      editSensitive: "敏感词编辑",
      sensitiveWords: "敏感词",
      shouldRecord: "是否记录",
      addTime: "添加时间",
      UpdateTime: "更新时间",
      toast1: "确定删除吗?"
    },
    // 丢单管理
    lostOrder: {
      keyWord: "丢单号/用户ID",
      startTime: "开始时间",
      endTime: "结束时间",
      dataType: "数据类型",
      topUp: "充值",
      gold: "金币",
      date: "日期",
      userID: "用户ID",
      nickname: "用户昵称",
      amountReceived: "到账金额(元)",
      agentRecharge: "代理充值()",
      text1: "到账金币"
    },
    account: {
      addAccount: "添加管理员帐号",
      edit: "编辑",
      ban: "禁用",
      unBan: "解除禁用",
      addTo: "已上架",
      unAddTo: "未上架",
      accountId: "管理员ID",
      username: "用户名",
      realname: "真实姓名",
      role: "角色",
      quotaPirce: "已用/配额金币",
      quotaGift: "已用/配额礼物",
      quotaProp: "已用/配额道具",
      lastLoginTime: "上次登录时间",
      fiveM: "5分钟",
      oneH: "1小时",
      twoH: "2小时",
      twelveH: "12小时",
      sureDelete: "确定删除？",
      sureBanAccount: "是否禁用该账号",
      sureUnBanAccount: "是否解除禁用该账号",
      text: "运营区域"
    },
    windDetail: {
      setAccount: "帐号设置",
      username: "用户名",
      newPassword: "新密码",
      checkPassword: "确认密码",
      realname: "真实姓名",
      role: "角色"
    },
    authorityManagement: {
      addRole: "添加角色",
      editRole: "编辑角色",
      editAuthority: "编辑权限",
      roleInfo: "角色信息",
      sort: "序号",
      roleName: "角色名称",
      authority: "权限编辑",
      role: "角色",
      text1: "模块权限管理",
      text2: "模块",
      text3: "运营名称",
      text4: "是否启用",
      text5: "模块权限设置",
      tabText2: "大R充值数据追踪",
      text6: "道具发放限制列表",
      text7: "授权名单"
    },
    menuagement: {
      add: "添加",
      editAuthority: "修改权限",
      menuName: "菜单名称",
      name: "名称",
      back: "返回",
      authorityName: "权限名称",
      sureDeleteMenu: "确认删除该菜单",
      sureDeleteAuthority: "确认删除该权限"
    },
    countryArr: {
      language1: "英语",
      language2: "阿语地区",
      language3: "印尼语地区",
      language4: "土耳其语地区",
      language5: "印地",
      language6: "越南语",
      language7: "泰语",
      language8: "西语",
      language9: "葡语"
    },
    stateManagement: {
      addCountry: "新增国家",
      tableText1: "国家名称",
      tableText2: "国家图标",
      updateCountry: "编辑国家",
      nameOrImgNotNull: "国家名称和国家图标不能为空"
    },
    hostManagement: {
      userId: "用户靓号",
      searchText1: "请输入用户靓号",
      searchText2: "请输入准确的用户ID",
      searchText3: "新增主播",
      searchText4: "用户管理",
      searchText4_1: "主播管理",
      searchText5: "分组管理",
      searchText6: "选择组",
      searchText7: "钻石清零列表",
      searchText8: "公会限制",
      tableText1: "头像",
      tableText2: "昵称",
      tableText3: "性别",
      tableText4: "财富/魅力",
      tableText5: "钻石余额",
      tableText6: "历史扣除钻石",
      tableText7: "金币余额",
      tableText8: "房间Id",
      tableText9: "本周房间流水",
      tableText10: "上周房间流水",
      tableText11: "上上周房间流水",
      tableText12: "上上上周房间流水",
      tableText13: "房间总流水",
      tableText14: "注册时间",
      tableText15: "最后登录时间",
      tableText16: "本周在线天数",
      tableText17: "本月在线天数",
      tableText18: "所在公会",
      operatText1: "修改分组",
      operatText2: "取消主播",
      operatText3: "扣除钻石",
      operatText4: "解除锁定",
      operatText5: "输入所需扣除",
      operatText6: "确定取消主播?",
      operatText7: "确定锁定钻石?",
      operatText8: "新增用户组",
      operatText8_1: "新增主播分组",
      operatText9: "修改用户组",
      operatText10: "锁定钻石",
      operatText11: "确定解锁钻石",
      table2Text1: "分组名",
      table2Text3: "分组id",
      table2Text2: "备注",
      warnText1: "请输入用户id",
      warnText2: "确定设为主播",
      warnText3: "确定取消主播",
      table3Text1: "时间",
      table3Text2: "扣除数",
      title3Text1: "钻石扣除记录",
      title4Text1: "房间贡献榜单前20",
      title4Text2: "本周",
      title4Text3: "上周",
      title4Text4: "上上周",
      title4Text5: "上上上周",
      title4Text6: "历史",
      table4Text1: "昵称",
      table4Text2: "靓号id",
      table4Text3: "贡献值",
      warnText4: "请输入分组名称",
      warnText5: "确认删除该分组信息",
      warnText6: "扣除钻石数量不能为空",
      warnText7: "确定修改分组",
      table5Text1: "清零前用户钻石余额",
      table5Text2: "房间靓号",
      table5Text3: "添加限制",
      table5Text4: "是否是会长",
      table5Text5: "清零钻石",
      table5Text6: "确认清零所选用户钻石",
      table5Text7: "设置会长",
      table5Text8: "确认修改会长?"
    },
    languageText: {
      areaText1: "英语地区",
      areaText2: "阿语地区",
      areaText3: "印尼语地区",
      areaText4: "土耳其语地区",
      areaText5: "印地语地区",
      areaText6: "越南语地区",
      areaText7: "泰语地区",
      areaText8: "西语地区",
      areaText9: "葡萄牙区"
    },
    agentManagement: {
      tabText1: "代理统计",
      tabText2: "代理充值",
      tabText3: "代理资料",
      tabText4: "月度销售统计",
      tabText5: "代理转账",
      search1Text1: "用户ID",
      table1Text1: "代理员ID",
      table1Text2: "头像",
      table1Text3: "昵称",
      table1Text4: "金币余额",
      table1Text5: "本月销售",
      table1Text6: "上月销售",
      table1Text7: "累计销售",
      table1Text8: "本月充值",
      table1Text9: "上月充值",
      table1Text10: "累计充值",
      table1Text11: "最近付款时间",
      table1Text12: "最近代充时间",
      table1Text13: " 24小时销售",
      table1Text14: " 充值金币",
      table1Text15: "充值白名单",
      table1Text16: "保护中",
      table1Text17: "已失效",
      table1Text18: "保护开始时间",
      table1Text19: "保护结束时间",
      table1Text20: "代理本月转出",
      table1Text21: "代理本月收到",

      opera1Text1: "ta的充值记录",
      opera1Text2: "代理充值",
      opera1Text3: "区域代理",
      opera1Text4: "选择国家",
      opera1Text5: "已选国家:",
      search2Text1: "代理充值",

      table2Text1: "发放时间",
      table2Text2: "代理id",
      table2Text3: "昵称",
      table2Text4: "充值金额",
      table2Text5: "充值金币",
      table2Text6: "支付方式",
      table2Text7: "支付备注",
      table2Text8: "发放人",
      table2Text9: "实际收款",
      table2Text10: "收款确认人",
      table2Text11: "确认时间",
      table2Text12: "充值编号",
      table2Text13: "实际收款",
      table2Text14: "账单流水号",
      table2Text15: "支付备注",
      table2Text16: "订单状态",
      table2Text17: "总充值",


      opera2Text1: "确认收款",
      opera2Text2: "取消订单",
      search3Text1: "增加代理信息",
      search3Text2: "编辑代理信息",
      table3Text1: "代理id",
      table3Text2: "代理区域",
      table3Text3: "常用付款方式",
      table3Text4: "付款账户名",
      table3Text5: "常驻国家",
      table3Text6: "电话",
      table3Text7: "微信号",
      table3Text8: "whatsapp",
      table3Text9: "邮箱",
      table3Text10: "salam id",
      table3Text11: "主要对接人",
      table3Text12: "是否保护",
      table3Text13:'代理类型',
      table3Text14:'官网采购单价',
      table3Text15:'二级代理',
      table4Text1: "年月",
      table4Text2: "土印区回款总额",
      table4Text3: "土印区回款月环比",
      table4Text4: "土印区销售总额",
      table4Text5: "土印区充值用户数",
      table4Text6: "土印区充值次数",
      table4Text7: "阿语区回款总额",
      table4Text8: "阿语区回款月环比",
      table4Text9: "阿语区销售总额",
      table4Text10: "阿语区充值用户数",
      table4Text11: "阿语区充值次数",

      table5Text1: "用户ID",
      table5Text2: "注册时间",
      table5Text3: "头像",
      table5Text4: "昵称",
      table5Text5: "充值金额()",
      table5Text6: "充值时间",
      table5Text7: "金币余额",
      table5Text8: "钻石余额",

      table5Text9: "代理余额",
      table5Text10: "转账金额",
      table5Text11: "转账用户",
      table5Text12: "转账用户ID",
      table5Text13: "转账用户余额",
      table5Text14: "转账时间",

      search5Text1: "导出报表",

      table6Text1: "充值金币",
      table6Text2: "充值金额()",
      table6Text3: "充值时间",
      table6Text4: "订单状态",
      table6Text5: "支付中",
      table6Text6: "已收款",
      table6Text7: "订单取消",
      table6Text8: "移除用户绑定",

      warnText1: "请选择国家",
      warnText2: "确认取消区域代理",
      warnText3: "该用户已设置代理国家",
      warnText4: "表单填写不能为空",
      warnText5: "代理Id不能为空",

      payType1: "汇丰转账",
      payType2: "花旗转账",
      payType3: "tap充值",
      payType4: "paypal",
      payType5: "支付宝",
      payType6: "西联支付",
      payType7: "代付费用",
      payType8: "茄子支付",
      payType9: "Payoneer",
      payType10: "checkout",
      payType11: "ebanx",
      payType12: "奖励",
      payType13: "补贴",

      proxyForm1: "代理Id",
      proxyForm2: "充值金额",
      proxyForm3: "金币数量",
      proxyForm4: "支付方式",
      proxyForm5: "支付备注",
      proxyForm6: "支付密码",
      proxyForm7: "账单流水号",
      proxyForm8: "取消原因",
      proxyForm9: "添加区域"
    },
    roomCrystal: {
      tabText1: "水晶礼物列表",
      tabText2: "水晶等级显示",
      tabText3: "水晶房间",
      table1Text1: "水晶等级",
      table1Text2: "道具名称",
      table1Text3: "水晶展示图标",
      table1Text4: "金币金额",
      table1Text5: "数量",
      table1Text6: "显示排序",
      table1Text7: "中奖概率",
      table1Text8: "有效时间",
      table1Text9: "有效时长(天)",
      table1Text10: "创建时间",
      opera1Text1: "新增金币",
      opera1Text2: "新增礼物",
      opera1Text3: "新增卡券",
      opera1Text4: "新增道具",
      table2Text1: "水晶等级一",
      table2Text2: "水晶等级二",
      table2Text3: "水晶等级三",
      table2Text4: "随机金币范围一",
      table2Text5: "随机金币范围二",
      table2Text6: "随机金币范围三",
      table2Text7: "随机金币阀值一",
      table2Text8: "随机金币阀值二",
      table2Text9: "随机金币阀值三",
      table2Text10: "随机金币概率",
      table2Text11: "图片特效",
      table2Text12: "请输入0-100"
    },
    // 活动管理
    ActivityManagement: {
      page1: "周星活动礼物设置",
      page2: "周星活动礼物",
      page3: "周星奖励配置",
      page1_1: "当前活动",
      page1_2: "历史活动",

      page2_1: "活动时间",
      page2_2: "周星礼物",
      page2_3: "送礼榜",
      page2_4: "房间送礼榜",
      page2_5: "日榜",
      page2_6: "周榜",
      page2_7: "房间/送礼榜",
      page2_8: "日/周榜",

      page3_1: "新增奖励",
      page3_2: "奖励名称",
      page3_3: "天数/数量",
      page3_4: "排名",
      page3_5: "奖励类型",
      page3_6: "礼物类型",

      rank1: "第1名",
      rank2: "第2名",
      rank3: "第3名",

      type1: "天奖励",
      type2: "周奖励",
      type3: "房间奖励",

      gift1: "小礼物",
      gift2: "中礼物",
      gift3: "大礼物",

      gtype1: "座驾/头饰",
      gtype2: "礼物总值",
      toast: "请选择周一",

      day1: "星期-",
      day2: "星期二",
      day3: "星期三",
      day4: "星期四",
      day5: "星期五",
      day6: "星期六",
      day7: "星期日",

      page4_1: "赛次",
      page4_2: "初赛排序",
      page4_3: "房间",
      page4_4: "参赛选手",
      page4_5: "选手票数",
      page4_6: "上架时间",
      page4_7: "下架时间",
      page4_8: "每天投票开始时间",
      page4_9: "每天投票结束时间",
      page4_10: "操作",

      page4_11: "初赛阶段",
      page4_12: "决赛阶段",
      page4_13: "活动信息",
      page4_14: "每天房间内部比赛开始时间",
      page4_15: "每天房间内部比赛结束时间",
      page4_16: "输入用户靓号ID,以英文状态下的逗号做间隔",
      page4_23: "国家名称,以英文状态下的逗号做间隔",

      page4_17: "其他区",
      page4_18: "票数",
      page4_19: "视频链接",
      page4_20: "图片",
      page4_21: "备注",
      page4_22: "其他区",
      page4_24: "点赞数",

      activityPage3tab1: "奖池设置",
      activityPage3tab2: "抽奖卷",

      activityPage3tab1txt1: "奖品ID",
      activityPage3tab1txt2: "奖品名称",
      activityPage3tab1txt3: "奖品类型",
      activityPage3tab1txt4: "价值",
      activityPage3tab1txt5: "有效期(天)",
      activityPage3tab1txt6: "有效时长(天)",
      activityPage3tab1txt7: "当前数量",
      activityPage3tab1txt8: "日均临界数量",
      activityPage3tab1txt9: "奖品概率",
      activityPage3tab1txt10: "上/下架",
      activityPage3tab1txt11: "是否推送",
      activityPage3tab1txt12: "是否公屏",
      activityPage3tab1txt13: "新增奖池",
      activityPage3tab1txt14: "是否上滚动",

      activityPage3tab1txt15: "单价(金币)",

      volume1: "用户ID",
      volume2: "用户昵称",
      volume3: "首次发放时间",
      volume4: "最近发放时间",
      volume0: "注册时间",
      volume5: "数量",
      volume55: "累计发放",

      volume6: "发放人",

      activityPage4tab1: "奖池设置",
      activityPage4tab2: "统计查询",
      activityPage4tab3: "兑换设置",
      activityPage7tab1: "表白墙",

      activityPage5txt1: "区域",
      activityPage5txt2: "充值等级",
      activityPage5txt3: "道具/金币数量",
      activityPage5txt3_1: "道具",
      activityPage5txt4: "道具类型",
      activityPage5txt5: "价值",
      activityPage5txt6: "数量/天数",
      activityPage5txt7: "操作",
      activityPage5txt8: "新增充值",
      activityPage5txt8_1: "编辑充值",
      activityPage5txt9: "删除选中项目",
      activityPage5txt10: "天数",

      activityPage6txt1: "新增奖励项",
      activityPage6txt2: "活动类型",

      activityPage6txt3: "周cp",
      activityPage6txt4: "周星奖励",
      activityPage6txt5: "月冠魅力",
      activityPage6txt6: "月冠贡献",
      activityPage6txt7: "CP认证",
      activityPage6txt8: "名次",
      activityPage6txt9: "奖励名称",
      activityPage6txt10: "性别",
      activityPage6txt11: "全部",
      activityPage6txt12: "男",
      activityPage6txt13: "女",

      activityPage7txt1: "CPID1",
      activityPage7txt2: "国家",
      activityPage7txt3: "CPID2",
      activityPage7txt4: "当前爱心数量",
      activityPage7txt5: "当前祝福数",
      activityPage7txt6: "上架时间",
      activityPage7txt7: "下架时间",

      activityPage7txt8: "表白ID",
      activityPage7txt9: "昵称",
      activityPage7txt10: "被表白ID",
      activityPage7txt11: "表白的话",
      activityPage7txt12: "发布时间",
      activityPage7txt13: "点赞数",
      activityPage7txt14: "消息内容",

      text1: "道具id",
      text2: "道具名称",
      text3: "接收者id",
      text4: "道具类型id",
      text5: "道具类型",
      text6: "发放理由",
      text7: "道具有效期",
      text8: "转换有效期",
      text9: "数量",
      text10: "转换有效期",
      text11:'通知文案',

      page6_1: "活动类型",
      page6_2: "周开始时间",
      page6_3: "区域",
      page6_4: "魅力榜单",
      page6_5: "贡献榜单",
      page6_6: "房间榜单",

      page6_7: "非土耳其",
      page6_8: "土耳其",
      page6_9: "区域",
      page6_10: "充值等级",
      page6_11: "请将信息填写完整",
      page6_12:'充值类型',

      page7_1: "活动名称",
      page7_2: "家族ID(左)",
      page7_3: "家族ID(右)",
      page7_4: "家族积分(左)",
      page7_5: "家族积分(右)",
      page7_6: "房间ID(左)",
      page7_7: "房间ID(右)",
      page7_8: "轮次",
      page7_9: "联赛列表",
      page7_10: "时间设置",
      page7_11: "晋级赛",
      page7_12: "1/4决赛",
      page7_13: "1/2决赛",
      page7_14: "总决赛",

      page8_1: "参赛国家",
      page8_2: "投票开始时间",
      page8_3: "投票结束时间",
      page8_4: "总决赛",
      page8_5: "总决赛",
      page8_6: "总决赛",

      page9_1: "旧周星",
      page9_2: "周CP",
      page9_3: "月冠",
      page9_4: "生日之星",
      page9_5: "新周星",
      page9_6: "活动类型",
      page9_7: "荣誉墙图片",
      page9_8: "跳转的url",
      page9_9: "添加时间",
      page9_10: "开始的时间",
      page9_11: "展示的结束时间",
      page9_12: "所属的区域",
      page9_13: "是否自动获取头像",
      page9_14: "新周星",
      page9_15: "荣誉墙图片",
      page9_16: "荣誉墙信息",

      page10_1: "房间PK",
      page10_2: "个人PK",
      page10_3: "家族PK",
      page10_4: "PK类别",
      page10_5: "pk_id(左)",
      page10_6: "积分(左)",
      page10_7: "pk_id(右)",
      page10_8: "积分(右)",
      page10_9: "pk开始时间",

      page10_10: "pk结束时间",
      page10_11: "pk类别",
      page10_12: "常规pk",
      page10_13: "赛季pk",
      page10_14: "PK信息",

      page11_1: "右边",
      page11_2: "左边",
      page11_3: "位置",

      page11_4: "128进32阶段",
      page11_5: "32进16阶段",
      page11_6: "16进8阶段",
      page11_7: "8进4阶段",
      page11_8: "4进2阶段",
      page11_9: "决赛阶段",
      page11_10: "winner",
      page11_11: "投票最终结束时间",
      page11_12: "票数结果",

      page11_13: "候选人ID",
      page11_14: "候选人昵称",
      page11_15: "票数",
      page11_16: "修改票数",
      page11_17: "确认修改票数？",
      page11_18: "参赛选手列表",

      page12_1: "参赛房间",
      page12_2: "参赛国家",

      activityPage4tab1txt1: "碎片数量",
      activityPage4tab1txt2: "当前数量",
      activityPage4tab1txt3: "日均临界数量",
      activityPage4tab1txt4: "奖品概率",
      activityPage4tab1txt5: "使用时长(天)",
      activityPage4tab1txt6: "存放有效期(天)",
      activityPage4tab1txt7: "日均临界数量",
      activityPage4tab1txt8: "轮播",
      activityPage4tab1txt9: "展示图标\n",
      activityPage4tab1txt10: "编辑奖品",
      page13_1: "婚礼",
      page13_2: "生日会",
      page13_3: "主持人",
      page13_4: "派对ID",
      page13_5: "派对类型",
      page13_6: "主持人靓号",
      page13_7: "主持人昵称",
      page13_8: "申请人靓号",
      page13_9: "用户1靓号",
      page13_10: "用户2靓号",
      page13_11: "通过备注",
      page13_12: "拒绝备注",


      // 1v1房间pk
      activityId:'活动ID',
      match:'轮次',

    },
    // 房间专栏
    roomColumn: {
      bannerImg: "banner图",
      tabText1: "房间banner",
      tabText2: "banner申核",
      tabText3: "发现页banner",
      table1Text1: "排序",
      table1Text2: "英语",
      table1Text3: "阿语",
      table1Text4: "西语",
      table1Text5: "土耳其语",
      table1Text6: "印地语",
      table1Text7: "越南语",
      table1Text8: "泰语",
      table1Text9: "印尼",
      table1Text10: "葡萄牙语",
      table1Text11: "下架时间",
      table1Text12: "封面图",
      table1Text13: "大图",
      table1Text14: "房间",
      table1Text15: "已上架",
      table1Text16: "未上架",
      table1Text17: "区域",
      table1Text18: "下架",
      table1Text19: "上架",
      table1Text20: "上下架时间",
      table1Text21: "上架时间",
      table1Text22: "下架时间",
      table1Text23: "注意：输入1代表在这个地区,不显示标题。",
      table1Text24: "专栏名称(英语)",
      table1Text25: "专栏名称(阿语)",
      table1Text26: "专栏名称(西语)",
      table1Text27: "专栏名称(土耳其语)",
      table1Text28: "专栏名称(印地语)",
      table1Text29: "专栏名称(越南语)",
      table1Text30: "专栏名称(泰语)",
      table1Text31: "专栏名称(印尼语)",
      table1Text32: "专栏名称(葡萄牙语)",
      table1Text33: "外图",
      table1Text34: "内图",
      table1Text35: "Banner跳转类型",
      table1Text35_1: "跳转类型",
      table1Text36: "H5",
      table1Text37: "帖子",
      table1Text38: "话题",
      table1Text39: "内图房间ID",
      table1Text40: "URL",
      table1Text41: "话题id/帖子id",
      table1Text42: "排序",
      table1Text43: "上架时间",
      table1Text44: "下架时间",
      table1Text45: "每天上架时间",
      table1Text46: "每天下架时间",
      table1Text47: "新增并复制关联功能",
      table1Text48: "请选择类型",
      table1Text49: "内图图片绑定ID",
      table1Text50: "H5链接",
      table1Text51: "请输入每天上架时间",
      table1Text52: "请输入每天下架时间",
      table1Text53: "排序输入框不能为空",
      table1Text54: "外图不能为空",
      table1Text55: "房间",
      table1Text56: "活动详情",
      table1Text58: "申请人ID",
      table1Text59: "印度区",

      table2Text57: "国籍",
      table2Text58: "房间ID",
      table2Text59: "房主ID",
      table2Text59_1: "申请人ID",
      table2Text60: "活动名称",
      table2Text61: "活动开始时间",
      table2Text62: "活动持续时长",
      table2Text63: "活动描述",
      table2Text64: "社媒账号",
      table2Text65: "社媒截图",
      table2Text66: "Banner截图",
      table2Text67: "地区",
      table2Text68: "小时",
      table1Text69: "确认执行上架操作",
      table1Text70: "确认执行下架操作",
      table1Text71: "上下架操作",
      table1Text72: "上架时间",
      table1Text73: "下架时间",
      table1Text74: "上架时间或者下架时间不能为空",
      table1Text75: "确认执行删除操作",
      table2Text76: "确认执行通过操作",
      table2Text77: "确认执行拒绝操作",
      table2Text78: "拒绝理由",

      table1Text78: "URL",
      table1Text79: "帖子id",
      table1Text80: "话题id",
      table1Text81: "房间id",
      table1Text82: "活动id",
      table1Text83: "请填写拒绝理由",
      table1Text106: "群id",

      table1Text84: "Banner URL/规则URL",
      table1Text85: "Banner 房间靓号/话题id/帖子id",
      table1Text86: "是否允许用户申请",
      table1Text87: "每天上架时间",
      table1Text88: "每天下架时间",
      table1Text89: "专栏房间列表",
      table1Text90: "认证级别",
      table1Text91: "本月扶持活动场次",
      table1Text92: "房间活动",
      table1Text93: "专栏活动",
      table1Text94: "图片尺寸不符合",
      table1Text95: "扶持活动",
      table1Text96: "专栏扶持活动",
      table1Text97: "添加banner",
      table1Text98: "添加专栏",
      table1Text99: "编辑banner",
      table1Text100: "编辑专栏",

      table1Text101: "即将上架",
      table1Text102: "申请人ID",
      table1Text103: "申请人ID或后台账号名",
      table1Text104: "上架房间",
      table1Text105: "已下架房间",


      table2Text1: "相亲 ",
      table2Text2: "板球",
      table2Text3: "电影秀",
      table2Text4: "脱口秀",
      table2Text5: "音乐",
      table2Text6: "幸运儿",
      table2Text7: "冲顶",
      table2Text8: "婚礼",
      table2Text9: "生日",
      table2Text10: "单身派对",
      table2Text11: "Banner专栏类型",
      table2Text12: "房间列表",

      table2Text13: "内图跳转类型",
      table2Text14: "内图 URL/规则URL",
      table2Text15: "内图 房间靓号/话题id/帖子id",
      table2Text16: "宾果游戏",
      table2Text17: "才艺秀",
      table2Text18: "诗歌",
      table2Text19: "猜谜",
      table2Text20: "房间专栏",

      //

      batchPass:'批量通过',
      batchReject:'批量拒绝',
      batchDelete:'批量删除',
      status:'状态',

    },
    // 设置
    setting: {
      tab1: "猜拳骰子设置",
      tab2: "靓号锁定",
      tab3: "最低版本号",
      tab4: "官方帐号",
      tab5: "金币任务",
      tab6: "活动黑名单设置",
      tab7: "ID商城",
      tab8: "ios控制版本号",
      tab9: "游戏黑名单",
      tab10: "每日任务奖励设置",
      tab11: "版本号设置",
      tab12: "官方账号设置",
      tab13: "ID锁定",
      tab14: "幸运盒子",
      tab15: "皮肤设置",

      tab1txt1: "猜拳、筛子入口:",
      tab1txt2: "正在展示",
      tab1txt3: "已屏蔽",
      tab1txt4: "确认展示猜拳、筛子入口？",
      tab1txt5: "确认屏蔽猜拳、筛子入口？",
      tab2txt1: "改备注",
      tab3txt1: "版本号",
      tab3txt2: "当前版本",
      tab4txt1: "官方房间",
      tab4txt2: "官方用户",
      tab4txt3: "新增用户",
      tab4txt4: "用英文,分隔",

      tab5txt1: "任务名称",
      tab5txt2: "任务类型",
      tab5txt3: "奖励金币",
      tab5txt4: "日常任务",
      tab5txt5: "成长任务",
      tab5txt6: "任务详情",
      tab5txt7: "签到页面",

      tab6txt1: "名称",
      tab6txt2: "位数",
      tab6txt3: "ID类型",
      tab6txt4: "添加id规格",
      tab6txt5: "ID反馈列表",
      tab6txt6: "ID位数",
      tab6txt7: "ID规格",
      tab6txt8: "靓号类型",
      tab6txt9: "金币价格",
      tab6txt10: "在售ID靓号数",
      tab6txt11: "管理靓号ID列表",
      tab6txt12: "二位数",
      tab6txt13: "三位数",
      tab6txt14: "四位数",
      tab6txt15: "五位数",
      tab6txt16: "六位数",
      tab6txt17: "七位数",
      tab6txt18: "八位数",
      tab6txt19: "同号",
      tab6txt20: "对子",
      tab6txt21: "连号",
      tab6txt22: "设置",

      tab7txt1: "提交时间",
      tab7txt2: "反馈ID",
      tab7txt3: "回复",
      tab7txt4: "忽略",
      tab7txt5: "已回复",
      tab7txt6: "已忽略",
      tab7txt7: "管理靓号ID列表",
      tab7txt8: "可以售卖",
      tab7txt9: "不可以售卖",
      tab7txt10: "锁定",
      tab7txt11: "已锁定"
    },
    communityLanguage: {
      language1: "英语",
      language2: "阿语",
      language3: "印尼语",
      language4: "土耳其语",
      language5: "印地语",
      language6: "越南语",
      language7: "泰语",
      language8: "巴西",
      language9: "西语",
      language10: "海湾组",
      language11: "印尼语",
      language12: "葡萄牙",
      language1Area: "英语区",
      language2Area: "阿语区",
      language3Area: "印尼语区",
      language4Area: "土耳其语区",
      language5Area: "印地语区",
      language6Area: "越南语区",
      language7Area: "泰语区",
      language8Area: "巴西区",
      language9Area: "西语区",
      language10Area: "印尼语区",
      language11Area: "葡萄牙语区",
      language12Area: "海湾地区"
    },

    // 违规用户操作
    violationUser: {
      table1Text1: "靓号",
      table1Text2: "头像",
      table1Text3: "昵称",
      table1Text4: "注册时间",
      table1Text5: "违规图片",
      table1Text6: "登录ip",
      table1Text7: "违规用户列表",
      table1Text8: "操作违规用户",
      table1Text9: "忽略",
      table1Text10: "封禁",
      table1Text11: "确认执行忽略操作",
      table1Text12: "确认执行封禁操作",
      table1Text13: "已封禁",
      table1Text14: "已忽略"
    },
    systemMessage: {
      upsign: "修改签名",
      uptip: "修改标签",
      uplove: "修改爱好",
      is_super: "是否超管",
      is_agent: "是否代理",
      is_admin: "是否国管",
      tabText1: "系统消息",
      tabText2: "消息反馈",
      // tabText3: "私信列表",
      tabText3: "发送私信",
      tabText4: "房间公屏信息",
      table1Text1: "发布时间",
      table1Text2: "标题",
      table1Text3: "内容",
      table1Text4: "图片",
      table1Text5: "URL",
      table1Text6: "地区",
      table1Text7: "再次删除",
      table1Text8: "发布系统消息",
      table1Text9: "已发布",
      table1Text10: "即将发送",
      table1Text11: "系统消息",
      table1Text12: "URL",
      table1Text13: "帖子",
      table1Text14: "话题",
      table1Text15: "房间",
      table1Text16: "活动详情",
      table1Text17: "跳转类型",
      table1Text18: "发送时间",
      table1Text19: "针对地区",
      table1Text20: "填写标题或内容不能为空",
      table1Text21: "再次发送",
      table1Text22: "针对国家",
      table1Text23: "群组详情",

      table2Text1: "请输入用户id搜索用户",
      table2Text2: "用户ID",
      table2Text3: "头像",
      table2Text4: "昵称",
      table2Text5: "截屏",
      table2Text6: "反馈内容",
      table2Text7: "反馈时间",
      table2Text8: "确认删除这条消息反馈",

      table3Text1: "用户ID",
      table3Text2: "发送内容",
      table3Text3: "发送时间",
      table3Text4: "请输入消息内容",
      table3Text5: "请输入url",
      table3Text6: "发送者ID 默认10000",
      table3Text7: "确认执行删除操作",
      table3Text8: "发送私聊信息",
      table3Text9: "发送者ID",
      table3Text10: "接收者ID",
      table3Text11: "私聊信息",
      table3Text12: "发送人",
      table3Text13: "请选择Excel(每份ID数量＜5000个)",

      table4Text1: "创建时间",
      table4Text2: "发布时间",
      table4Text3: "消息内容",
      table4Text4: "跳转类型",
      table4Text5: "上线地区",
      table4Text6: "操作人",

      table4Text7: "不跳转",
      table4Text8: "H5",
      table4Text9: "充值页面",
      table4Text10: "指定房间",
      table4Text11: "用户资料页",
      table4Text12: "商城页",
      table4Text13: "贵族购买页",
      table4Text14: "跳转话题",
      table4Text15: "跳转帖子",

      table4Text16: "消息内容(英文)",
      table4Text17: "消息内容(土耳其)",
      table4Text18: "消息内容(阿语)",
      table4Text19: "消息内容(印尼)",
      table4Text20: "消息内容(葡萄牙语)",
      table4Text21: "消息内容(印地语)",
      table4Text22: "消息内容(西语)",
      table4Text23: "消息内容(泰国)",
      table4Text24: "消息内容(越南)",
      table4Text25: "指定房间",
      table4Text26: "指定用户",
      table4Text27: "话题ID/帖子ID",
      table4Text28: "发送时间",
      table4Text29: "指定用户",
      table4Text30: "发送房间公屏信息",
      table4Text31: "跳转参数",
      table4Text32: "取消发送",
      table4Text33: "再次发送",
      table4Text34: "今日发送",
      table4Text35: "30日内发送",
      table4Text36: "消息内容",
      table4Text37: "是否同步至发送者",

      warningMsg:'请选择针对地区',

      overLimit:'超过最大限制字符',

    },
    // 邀请信息管理
    invitationMessage: {
      text1: "查看邀请详情",
      text2: "邀请等级",
      text3: "邀请信息",
      text4: "绑定关系",
      text5: "邀请原因",
      text6: "绑定时间",
      text7: "负责人",
      text8: "最后登陆时间",
      text9: "用户等级(财富/魅力)",

      text10: "邀请者靓号",
      text11: "被邀请者靓号",
      text12: "邀请列表",
      text13: "邀请人数",
      text14: "今日邀请人",
      text15: "最近7天邀请人",
      text16: "最近30天邀请人",
      text17: "添加推广员",
      text18: "历史邀请",
      text19: "批量绑定",
      text20: "确认绑定",
      //
      promoter: "推广员",
      promoter_no: "推广员ID",

      invitee: "被邀请人",
      invitee_no: "被邀请人ID",

    },
    developerMessage: {
      send_price: "金币配额",
      send_gift: "礼物配额",
      send_prop: "道具配额",
      page1Text1: "逻辑ID",
      page1Text2: "用户ID",
      page1Text3: "设备ID",
      page2Text1: "IP",
      page2Text2: "添加时间",
      page2Text3: "逻辑id",

      page5Text1: "注册ip统计",
      page5Text2: "注册设备统计",
      page5Text3: "登陆统计",
      page5Text4: "登陆异常",
      page5Text5: "当前次数",
      page5Text6: "统计时间",
      page5Text7: "注册次数",
      page5Text8: "登录用户",
      page5Text9: "登录类型",
      page5Text10: "登录时间",
      page5Text11: "触发次数",

      page6Text1: "本月允许发放礼物金币总数",
      page6Text2: "本月允许发放非礼物发放次数",
      page6Text3: "创建时间",
      page6Text4: "修改时间",
      page6Text5: ""
    },
    kaManagement: {
      rechargeTotal:'充值总额',
      add:'新增',

      addResult:'添加结果',
      tipsText1:'用英文,分隔',
      tipsText2:'个用户添加成功',
      tipsText3:'以下用户已存在',
      tipsText4:'以下用户添加失败',

    },
    ...blindBox,
    ...auction,
    ...approval,
    ...groupActivity,
    ...worldCup,
    ...nameplate,
    platform: {
      tab1: '月充值',
      tab2: '日充值',
      tab3: '充值明细',
      tab4: '金币消耗月统计',
      tab5: '金币消耗日统计',
      tab6: '任务完成明细',
      tab7: '任务统计',
      tab8: '日充值查询',
      tab9: '代理充值',
      tab10: '退款明细',
      tab11: '冻结明细',
      tab12: '消费明细',
      tab13: '钻石明细',
      tab14:'财务对账',
      tab15:'新建房间统计',
      tab16:'日活跃房间统计',
      tab17:'周活跃房间统计',
      tab18:'大房流水统计',
      tab19:'大R充值统计',
      tab20:'星级房间统计',
      tab21:'金币兑换明细',
      tab22:'30天首充用户',
      tab23:'大R复购统计',
      tab24:'退款及冻结',
      tab25:'活跃房间统计',
      tab26:'活跃家族统计',

      tab1Sub1: '当日数据延迟30分钟左右计算',
      tab1Sub2: '当月数据延迟30分钟左右计算',

      platformRechargeDetail1: '充值到账时间',
      platformRechargeDetail2: '到账用户id',
      platformRechargeDetail3: '到账用户姓名',
      platformRechargeDetail4: '到账金额',
      platformRechargeDetail5: '金币数量',
      platformRechargeDetail6: '币种',
      platformRechargeDetail7: '充值类型',
      platformRechargeDetail8: '订单号',
      platformRechargeDetail9: '金额降序',
      platformRechargeDetail10: '金额升序',
      platformRechargeDetail11: '支付类型',
      platformRechargeDetail12: '排序',
      platformRechargeDetail13: '时间降序',
      platformRechargeDetail14: '时间升序',

      platformGoldMonth: '年月',

      platformGoldDay1: '日期',
      platformGoldDay2: '礼物消费',
      platformGoldDay3: '猜拳消费',
      platformGoldDay4: '成为房间会员',
      platformGoldDay5: '全服喇叭',
      platformGoldDay6: '召唤粉丝',
      platformGoldDay7: '召唤会员',
      platformGoldDay8: '房间置顶',
      platformGoldDay9: '房间加锁',
      platformGoldDay10: '创建房间',
      platformGoldDay11: '创建家族',
      platformGoldDay12: '任务奖励',
      platformGoldDay13: '商城购买',
      platformGoldDay14: '其它',
      platformGoldDay15: 'pk消耗',
      platformGoldDay16: '投票消耗',
      platformGoldDay17: '充值金币数',
      platformGoldDay18: '发放金币数',
      platformGoldDay19: '房间任务',
      platformGoldDay20: '家族奖励(钻石数)',
      platformGoldDay21: '房间奖励(钻石数)',

      platformDetail: '用户ID',

      platformTask1: '日期',
      platformTask2: '上麦10分钟',
      platformTask3: '上麦1小时',
      platformTask4: '分享房间一次',
      platformTask5: '发起PK',
      platformTask6: '送出3个礼物',
      platformTask7: '任意等级5级',
      platformTask8: '任意等级10级',
      platformTask9: '创建房间',
      platformTask10: '发布活动',
      platformTask11: '组成CP',
      platformTask12: '创建家族',
      platformTask13: '首充',
      platformTask14: '合计',

      platformRecharge1: '到账用户id',
      platformRecharge2: '到账用户姓名',
      platformRecharge3: '到账总金额(美元)',
      platformRecharge4: '总充值次数',

      payType1: '微信',
      payType2: '支付宝',
      payType3: '苹果支付',
      payType4: '谷歌支付',
      payType5: 'palpay支付',
      payType6: '代理充值',
      payType7: '代理内部充值',
      payType8: '电商充值',
      payType9: 'payssion支付',
      payType10: 'tap支付',
      payType11: '华为支付',
      // payType12: '茄子快传支付',
      payType12: 'payermax支付',
      payType13: 'dlocal充值',
      payType14: 'paypal充值',
      payType15: 'checkout充值',

      payWay1: '人民币',
      payWay2: '美元',

      agentTableText1: '代理靓号',
      agentTableText2: '用户ID',
      agentTableText3: '注册时间',
      agentTableText4: '头像',
      agentTableText5: '昵称',
      agentTableText6: '充值金币',
      agentTableText7: '充值金额（美元）',
      agentTableText8: '充值时间',
      agentTableText9:'代理总充值',

      agentTableText10:'当日充值金币',
      agentTableText10_1:'当月充值金币',
      agentTableText11:'当日充值金额',
      agentTableText11_1:'当月充值金额',

      table5Text1: '退款人',
      table5Text2: '退款时间',
      table5Text3: '订单号',
      table5Text4: '用户靓号',
      table5Text5: '请输入用户靓号',
      table5Text6: '退款金币数(美金数)',
      table5Text7: '昵称',
      table5Text8: '国家',
      table5Text9: '注册时间',
      table5Text10: '等级(财富/魅力)',
      table5Text11: '账户金币余额',
      table5Text12: '谷歌/苹果充值总额',
      table5Text13: '封禁至',
      table5Text14: '永久封禁',
      table5Text15: '注册IP',
      table5Text16: '国家',
      table5Text17: '累积退款金额',
      table5Text18: '冻结',
      table5Text19: '未冻结',
      table5Text20: '是否冻结',
      table5Text21: '充值时间',
      table5Text22: '谷歌以扫描时间为准，苹果以收到通知时间为准',
      table5Text23:'当前国家',
      table5Text24:'退款时国家',
      table5Text25:'支持查找最近6个月的数据',

      table6Text1: '冻结账户',
      table6Text2: '冻结金币数（美金数）',
      table6Text3: '昵称',
      table6Text4: '国家',
      table6Text5: '最近退款金额',
      table6Text6: '注册IP',
      table6Text7: '等级(财富/魅力)',
      table6Text8: '账户金币余额',
      table6Text9: '充值总额',
      table6Text10: '冻结时间',
      table6Text11: '订单号',
      table6Text12: '注册时间',
      table6Text13: '冻结操作员',
      table6Text14: '冻结明细',

      table6Text15:'是否首充',
      table13Text1:'查看明细',
      tab7text1:'渠道类型',
      tab7text2:'用户靓号',
      tab7text3:'支付时间',
      tab7text4:'充值金额',
      tab7text5:'货币类型',
      tab7text6:'到账金币数',
      tab7text7:'订单号',
      tab7text8:'',
      tab7text9:'',

      table7Text1:'三方渠道',
      table7Text2:'收款总额',

      table8Text1:'最低月环比',
      table8Text2:'月环比%',

    },
    statistics: {
      tab1: '活跃按周统计',
      tab2: '活跃按日统计',
      tab3: '新增按周统计',
      tab4: '新增按日统计',
      tab5: '付费用户按周统计',
      tab6: '付费用户按日统计',
      tab7: '活跃房间按周统计',
      tab8: '活跃房间按日统计',
      tab9: '每日道具消费统计',
      tab10: '每周道具消费统计',
      tab14: '每月道具消费统计',

      // tab11: "西语区接待统计",
      tab11:"官方房间接待统计",
      tab12:"接待人员",
      tab13:"认证房间统计",

      // 活跃按周统计
      week1: '日期',
      week2: '有效周活_帐号',
      week3: '有效周活次留_帐号',
      week4: '普通周活_帐号',
      week5: '普通周活次留_帐号',
      week6: '激活状态',
      week7: '国家',
      week8: '系统类型',

      // 活跃按日统计
      date1: '日期',
      date2: '有效日活_帐号',
      date3: '有效日活次留_帐号',
      date4: '普通日活_帐号',
      date5: '普通日活次留_帐号',
      date6: '是否已激活用户',
      date7: '国家',
      date8: '系统类型',

      // 新增按周统计
      addWeek1: '日期',
      addWeek2: '有效新增_帐号',
      addWeek3: '有效新增次留_帐号',
      addWeek4: '普通新增_帐号',
      addWeek5: '普通新增次留_帐号',
      addWeek6: '国家',
      addWeek7: '系统类型',

      // 新增按日统计
      addDate1: '日期',
      addDate2: '有效新增_帐号',
      addDate3: '有效新增次留_帐号',
      addDate4: '普通新增_帐号',
      addDate5: '普通新增次留_帐号',
      addDate6: '国家',
      addDate7: '系统类型',

      // 付费用户按周统计
      costWeek1: '日期',
      costWeek2: '有效周活',
      costWeek3: '有效次留',
      costWeek4: '普通周活',
      costWeek5: '普通次留',
      costWeek6: '当周付款人数',
      costWeek7: '付款用户普通次留',
      costWeek8: '当周付款次数',
      costWeek9: '当周付款金额',
      costWeek10: '国家',
      costWeek11: '系统类型',

      // 付费用户按日统计
      costDate1: '日期',
      costDate2: '有效日活',
      costDate3: '有效次留',
      costDate4: '普通日活',
      costDate5: '普通次留',
      costDate6: '当日付款人数',
      costDate7: '付款用户普通次留',
      costDate8: '当日付款次数',
      costDate9: '当日付款金额',
      costDate10: '国家',
      costDate11: '系统类型',

      // 活跃房间按周统计
      activeWeek1: '日期',
      activeWeek2: '国家',
      activeWeek3: '房间热度(0-10)',
      activeWeek4: '房间热度(10-20)',
      activeWeek5: '房间热度(20-50)',
      activeWeek6: '房间热度(50-100)',
      activeWeek7: '房间热度(100-500)',
      activeWeek8: '房间热度(500-1K)',
      activeWeek9: '房间热度(1K-2K)',
      activeWeek10: '房间热度(2K-5K)',
      activeWeek11: '房间热度(5K以上)',
      activeWeek12: '合计',

      // 活跃房间按日统计
      activeDate1: '日期',
      activeDate2: '国家',
      activeDate3: '房间热度(0-10)',
      activeDate4: '房间热度(10-20)',
      activeDate5: '房间热度(20-50)',
      activeDate6: '房间热度(50-100)',
      activeDate7: '房间热度(100-500)',
      activeDate8: '房间热度(500-1K)',
      activeDate9: '房间热度(1K-2K)',
      activeDate10: '房间热度(2K-5K)',
      activeDate11: '房间热度(5K以上)',
      activeDate12: '合计',

      // 礼物分类按日统计
      giftDate1: '日期',
      giftDate2: '礼物销售额',
      giftDate3: '座驾销售额',
      giftDate4: '头饰销售额',
      giftDate5: '主题销售额',
      giftDate6: '贵族销售额',
      giftDate7: '销售额总计',
      giftDate8:'礼物销量',
      giftDate9:'座驾销量',
      giftDate10:'头饰销量',
      giftDate11:'主题销量',
      giftDate12:'贵族销量',
      giftDate13:'个人飘屏销量',
      giftDate14:'个人飘屏销售额',
      giftDate15:'聊天气泡销量',
      giftDate16:'聊天气泡销售额',

      activeStatus: '已激活',
      unActiveStatus: '未激活',
      system1: 'android系统',
      system2: 'IOS系统',

      warnText1: '此数据仅作参考',

      // 西语区接待统计
      spanishRec1: "请输入用户靓号",
      spanishRec2: '请输入房间ID',
      spanishRec3: '新增接待',
      spanishRec3_1: '修改接待',
      spanishRec4: "日期",
      spanishRec5: "时间段",
      spanishRec6: "用户靓号",
      spanishRec7: "房间ID",
      // spanishRec8: "用户备注",
      spanishRec8: "用户昵称",
      spanishRec9: "上麦时长 min",
      spanishRec10: "送礼金币数",
      spanishRec11: "新用户收礼占比",
      spanishRec12a: "新用户上麦率1",
      spanishRec12b: "新用户上麦率",

      //
      spanishRec13: "逻辑ID",
      spanishRec14: "请输入逻辑ID",
      spanishRec15: "接待备注",
      spanishRec16: "请输入昵称备注",
      spanishRec17: "房间ID",
      spanishRec18: "请输入接待服务的房间ID",
      spanishRec19: "工作时段",
      spanishRec20: "请输入工作时段",
      spanishRec21: "备注",
      spanishRec22: "区域",

      spanishRec23: "用户id",
      spanishRec24: "新用户收礼人数",
      spanishRec25: "新用户上麦人数",
      spanishRec26: "新用户人数",
      spanishRec27: "房间流水",
      spanishRec28: "充值人数",
      spanishRec29: "流水",
      spanishRec30: "本周充值",
      spanishRec31: "总充值",


      spanishRec_lan_enar: "英阿区",
      spanishRec_lan_tr: "土耳其语区",
      spanishRec_lan_hi: "印地语区",
      spanishRec_lan_vi: "越南语区",
      spanishRec_lan_th: "泰语区",
      spanishRec_lan_es: "西班牙语区",
      spanishRec_lan_id: "印尼语区",
      spanishRec_lan_pt: "葡萄牙语区",
      spanishRec_lan_india:'印度语区',


      //

    },
    roomDataTrack: {
      tabText1: '房间流水追踪',
      tabText2: '大R充值数据追踪',
      tabText8: '国家运营数据',
      tabText9:'30天新R',
      tableText1: '状态预警',
      clickSort: '↑↓',
      tableText2: '原始ID',
      tableText3: '靓号ID',
      tableText4: '昵称',
      tableText5: '头像',
      tableText6: '国家',
      tableText7: '累计充值',
      tableText8: '上上周充值',
      tableText9: '上周充值',
      tableText10: '本周充值',
      tableText11: '上上月充值',
      tableText12: '上月充值',
      tableText13: '本月充值',
      tableText28: '当日充值',
      tableText29: '注册时间',
      tableText30: '最后登录时间',
      tableText31: '上上上月充值',
      tableText32: '充值最大值',
      tableText33: '充值最小值',
      tableText34: '本月充值最小值',
      tableText35: 'SVIP等级',

      search1: '地区',
      search2: '国家',
      search3: '预警级别',
      search4: '房间靓号',
      search3Op1: '绿色',
      search3Op2: '蓝色',
      search3Op3: '黄色',
      search3Op4: '橙色',
      search3Op5: '红色',
      search5: '任意月充值区',
      search6: '用户靓号',
      search7: '请输入用户靓号ID',
      search8: '本月充值区间',
      search9: '月份',
      search10: '用户靓号',
      search9Opt1: '本月',
      search9Opt2: '上月',
      search9Opt3: '上上月',
      search9Opt4: '上上上月',
      tabText3: '自充',
      tabText4: '代充',
      tabText5: '合计',
      tabText6: '分组管理',
      tabText7: '分组',

      table2Text1: '房间靓号ID',
      table2Text2: '房间名称',
      table2Text3: '房主ID',
      table2Text4: '房主昵称',
      table2Text5: '房间创建时间',
      table2Text6: '房间等级',
      table2Text7: '当前热度',
      table2Text8: '总流水(金币)',
      table2Text9: '房间今日流水',
      table2Text10: '房间昨日流水',
      table2Text11: '房间前天流水',
      table2Text12: '房间本周流水',
      // table2Text13: '房间上周流水(从周日算起)',
      // table2Text14: '房间上上周流水(从周日算起)',
      table2Text13: '房间上周流水',
      table2Text14: '房间上上周流水',
      table2Text15: '房间本月流水',
      table2Text16: '房间上月流水',
      toPageBtn1: '查看充值明细',
      toPageBtn2: '查看互动名单',
      titleName1: '充值明细',
      table3Text1: '日期',
      table3Text2: '充值总额',

      searchText7: '当前条件大r人数',

      table4Text1: '区间',
      table4Text2: '大R复购用户',
      table4Text3: '本月充值大R',
      table4Text4: '上月充值大R',
      table4Text5: '复购率',
      table4Text6: '大R未复购用户数',
      table4Text7: '大R新增用户数',

      select1Text1: '用户本周未充值',
      select1Text2: '用户上周至本周未充值',
      select1Text3: '用户上上周至本周未充值',
      select1Text4: '用户本月未充值',
      select1Text5: '用户45天未充值',
      searchText8: '2021年3月前汇率以6.5统计，之后汇率以充值当天汇率计算',

      searchText9: '此页面汇率为当天统计时汇率',

      searchText10: '充值数据最早统计时间{time}，汇率为统计时汇率',
      searchText11: '此模块数据还在统计中，还未完成，请等待',
      searchText12:'当前查询用户数',

      table5Text1: '分组',
      table5Text2: '负责运营',
      table5Text3: '用户逻辑ID',
      table5Text4: '新增分组',
      table5Text5: '编辑分组',
      table5Text6: '分组名称',
      table5Text7: '包含ID',
      table5Text8: '新增',
      notNullWarn1: '分组名称和包含ID不能为空',
      checkDelWarn1: '确认删除该条分组',
      table5Text9: '多个ID时用逗号隔开，ID前后不要有空格',
      table5Text10: '用户靓号',
      table6Text1: '用户列表',
      table6Text2: '靓号',
      table6Text3: '本月金额',
      table6Text4: '上月金额',
      table6Text5: '认证级别',
      table6Text6: '用户类别',
      table6Text7: '拉新用户',
      table6Text7_1: '召回用户',
      table6Text8: '上月最小充值',
      table6Text9: '上月最大充值',
      table6Text10:'本月开始日期',
      table6Text11:'上月开始日期',
    },
    hostManagement: {
      pleaseEnter: '请输入用户靓号或昵称',
      tabText1: '头像',
      tabText2: '昵称',
      tabText3: '性别',
      tabText4: '财富/魅力/活跃',
      tabText5: '钻石余额',
      tabText6: '历史扣除钻石',
      tabText7: '金币余额',
      tabText8: '房间Id',
      tabText9: '本周房间流水',
      tabText10: '上周房间流水',
      tabText11: '上上周房间流水',
      tabText12: '上上上周房间流水',
      tabText13: '房间总流水',
      tabText14: '注册时间',
      tabText15: '最后登录时间',
      tabText16: '本周在线天数',
      tabText17: '本月在线天数',

      tabText18: '上月',
      tabText19: '本月',
      tabText20: '昵称',
      tabText21: '收到',
      tabText22: '用户靓号',
      tabText23: '金币数',
      tabText24: '靓号id',
      tabText25: '贡献值',
      tabText26: '赠与',

      tabText31: '前天',
      tabText32: '昨天',
      tabText33: '今天',
      tabText34: '上上周',
      tabText35: '上周',
      tabText36: '本周',


      hostTitle: '房间贡献榜单前20',
      showList: '查看互动名单',

      hostTitle2: '{userId}从{time}至今的互动榜单',
      hostTitle3: '{userId}至今的互动榜单',

      tabText27: '今日上麦时长(主播房间)',
      tabText28: '本周上麦时长(主播房间)',
      tabText29: '历史上麦时长(主播房间)',
      tabText30: '进入房间数据',
      tabText37: '本周上麦≥1h天数(主播房间)',
      tabText38: '上周上麦≥2h天数(主播房间)',
      tabText39: '本月上麦≥1h天数(主播房间)',

      showDetail: '查看',

      joinTime: '进入时间',
      endTime: '离开时间',
      roomNumber: '房间靓号',
      joinLong: '进入时长',
      unLeave: '未离开',
      titleText1: '目前只统计了大R的互动数据',
      titleText2: '数据延迟15分钟左右',

      modalTableText1: '日期',
      modalTableText2: '上麦时长',
      tabText40: '上周净增钻石',
      tabText41: '本周净增钻石',
      tabText42: '本月净增钻石',

      tabText43: '上周上麦时长（任意房间）',
      tabText44: '本周上麦时长（任意房间）',
      tabText45: '历史上麦时长（任意房间）',
      tabText46: '本周上麦≥2h天数（任意房间）',
      tabText47: '上周上麦≥2h天数（任意房间）',
      tabText48: '本月上麦≥2h天数（任意房间）',
      tabText49: '本周收礼人数（与主播同一区域）',
      tabText50: '上周收礼人数（与主播同一区域）',
      tabText51: '本月收礼人数（与主播同一区域）',
      tabText52: '本月上麦≥2h天数（主播房间）',
      tabText53: '本周上麦≥2h天数（主播房间）',
      tabText54: '上月收礼人数（与主播同一区域）',
      tabText55: '昵称',
      tabText56: '靓号id',
      tabText57: '贡献金币',
      tabText58: '贡献钻石',
      tabText59: '退款金额',
      tabText60: '主播上周上麦时长（主播房间）',
      tabText61: '备注',
      tabText62: '贡献者详情数据还在统计中',
      tabText63: '时长明细',
      tabText64: '请输入用户靓号',
      tabText65: '房间id',
      tabText66: '按时间查找',
      tabText67: '上周收礼人数（与主播同一区域）',
      tabText68: '上月上麦≥2h天数（主播房间）',
      tabText69:'上周主播收礼人数（在主播房间送礼给主播用户数）',
      tabText70:'本月主播收礼人数（在主播房间送礼给主播用户数）',
      tabText71:'主播上周收礼金币(主播上周收到的全部礼物金币价值)',
      tabText72:'主播本月收礼金币(主播本月收到的全部礼物金币价值)',
      tabText73:'本月房间流水',
      tabText74:'主播上月上麦时长（主播房间）',
      tabText75:'',
      tabText76: '房间热度最小值',
      tabText77: '房间热度最大值',
    },

    ...community,
  },
  components: {
    banModal: {
      chooseTime: "选择封禁时间",
      chooseReason: "选择原因：",
      banReason: "封禁原因：",
      content: "举报内容：",
      enterContent: "可输入举报内容",
      enterUrl: "可输入图片或视频链接",
      imgVideoUrl: "图片或视频链接：",
      banUser: "确认封禁该用户？"
    },
    publicCheckBan: {
      checkBan: '安全校验',
      checkError: '校验错误',
      checkSuccess: '校验成功',
      nameNotNull: '填写不能为空',
      enterUserName: '请输入用户名校验',
    },
    loginForm: {
      enterUserName: "请输入用户名",
      enterPassword: "请输入密码",
      login: "登录",
      accountNotNone: "账号不能为空",
      passwordNotNone: "密码不能为空"
    },
    fullScreen: {
      exitScreen: "退出全屏",
      fullScreen: "全屏"
    },
    headerBar: {
      title: "Gama管理系统V1.0"
    },
    tagsNav: {
      closeAll: "关闭所有",
      closeOther: "关闭其他"
    },
    user: {
      signOut: "退出系统",
      accountInformation: "账号信息",
    },
    accountInfo: {
      username: "姓名",
      role: "角色",
      operatingArea: "所属运营区域",
      // quotaGift: "已用/配额礼物",
      // quotaPirce: "已用/配额金币",
      // quotaProp: "已用/配额道具",
      quotaGift: "礼物配额",
      quotaGold: "金币配额",
      quotaProp: "道具配额",
    },
    publicCheckPassword: {
      checkPassword: "输入操作密码，并确认",
      checkSuccess: "校验成功"
    },
    tableBox: {
      noneData: "暂无数据"
    },
    tableSearch: {
      search: "查询条件",
      searchOrOperat: "查询条件和操作"
    }
  },
  js: {
    request: {
      systemError: "服务器系统内部错误",
      unLogin: "未登录",
      timeOut: "请求超时",
      linkError: "网络连接失败",
      unknownMis: "未知错误"
    },
    httpJs: {
      exportNull: "当前导出的内容为空"
    }
  },

  home: {
    test: "测试"
  },
  ...jZh,
  ...liveManagement,
  ...revenueActivity,
  ...annualFestival,
  ...newStarRoom,
  ...groupManagement,
};



// WEBPACK FOOTER //
// ./src/language/zh-cn.js